import moment from "moment";
import Modal from "react-modal";
import css from "./TimeOff.css";
import { toast } from "react-toastify";
import subDays from "date-fns/subDays";
import { DateRangePicker } from "rsuite";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import isEqual from "lodash/isEqual";
import Type from "../../images/icons/type.svg";
import { ResizeObserver } from 'resize-observer';
import Delete from "../../images/icons/delete.svg";
import editImage from "../../images/icons/edit-pen.svg";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import PlusIcon from "../../images/icons/plus-icon.svg";
import LoadingSpinner from "../Animations/LoadingSpinner";
import React, { useState, useEffect, useRef } from "react";
import DateConverter from "../../helpers/dateFormatChange";
import TimeConverter from "../helpers/timeFormatConverter";
import birthIcon from "../../images/icons/dat-of-birth.svg";
import timer from "../../images/icons/timer.svg";
import { logout, reset } from "../../features/auth/authSlice";
import profile_image from "../../images/user/Default_pfp.png";
import UserIcon from "../../images/icons/single-user-icon.svg";
import UpArrowImage from "../../images/icons/up-down-arrow.svg";
import DownArrowImage from "../../images/icons/up-down-arrow.svg";
import tikgImage from "../../images/singleinvoice/tick-green.svg";
import crssrImage from "../../images/singleinvoice/cross-red.svg";
import cancelImage from "../../images/singleinvoice/cancel.svg";
import DownloadImage from "../../images/icons/download-icon.svg";
import userTypeConsts from "../../constants/userTypeConsts";
import { setHeaderText } from "../../features/headerText/headerTextSlice";
import { reset as invoiceReset } from "../../features/invoice/invoiceSlice.js";
import { setNotification } from "../../features/notification/notificationSlice.js";
import { reset as headerReset } from "../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset, setAppLoading } from "../../features/appSettings/appSettingsSlice.js";
import { useActiveUser, useApproveTimeOffRequest, useCancelTimeOffRequest, useCreateTimeOffRequest, useDeleteTimeOffRequest, useFetchLeaveTypes, useRejectTimeOffRequest, useUserById, useTimeOffRequestsOptimized, useUpdateTimeOffRequest } from "./timeOffApi";
import TruncateFilterFieldView from "../helpers/truncateFilterFieldView.js";
import TruncateUserName from "../helpers/truncateUserName.js";
import Calendar from "../../helpers/dateComponents/Calendar";
import { motion } from 'framer-motion';
import { TimeOffDetailsModal, TimeOffActions, TimeOffTable, TimeOffPagination, TimeOffTableSkeleton } from "./components";

const TimeOffs = () => {

  const SUPER_ADMIN = 1;
  const ADMIN = 2;
  const USER = 3;
  const PROJECT_MANAGER = 6;
  const TEAM_MANAGER = 7;
  const timeList = [
    {
      time_value: 9,
      time: "09:00AM",
    },
    {
      time_value: 9.5,
      time: "09:30AM",
    },
    {
      time_value: 10,
      time: "10:00AM",
    },
    {
      time_value: 10.5,
      time: "10:30AM",
    },
    {
      time_value: 11,
      time: "11:00AM",
    },
    {
      time_value: 11.5,
      time: "11:30AM",
    },
    {
      time_value: 12,
      time: "12:00PM",
    },
    {
      time_value: 13,
      time: "01:00PM",
    },
    {
      time_value: 13.5,
      time: "01:30PM",
    },
    {
      time_value: 14,
      time: "02:00PM",
    },
    {
      time_value: 14.5,
      time: "02:30PM",
    },
    {
      time_value: 15,
      time: "03:00PM",
    },
    {
      time_value: 15.5,
      time: "03:30PM",
    },
    {
      time_value: 16,
      time: "04:00PM",
    },
    {
      time_value: 16.5,
      time: "04:30PM",
    },
    {
      time_value: 17,
      time: "05:00PM",
    },
    {
      time_value: 17.5,
      time: "05:30PM",
    },
    {
      time_value: 18,
      time: "06:00PM",
    },
    {
      time_value: 18.5,
      time: "06:30PM",
    },
  ];
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [filter, setFilter] = useState("");
  const [filterSearch, setFilterSearch] = useState("");
  const filterDebounceTimeout = useRef(null);
  const [userFilter, setUserFilter] = useState("All");
  const [statusFilter, setStatusFilter] = useState("All");
  const [perPage, setPerPage] = useState(10);
  const [selectedId, setSelectedId] = useState("");
  const [profilePhoto, setProfilePhoto] = useState("");
  const [profileName, setProfileName] = useState("");
  const [issueDate, setIssueDate] = useState("");
  const [totalHours, setTotalHours] = useState("");
  const [startDate, setStartDate] = useState("");
  const [torStatus, setTorStatus] = useState("");
  const [endDate, setEndDate] = useState("");
  const [verifiedByProfilePhoto, setVerifiedByProfilePhoto] = useState("");
  const [verifiedByProfileName, setVerifiedByProfileName] = useState("");
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isRejectModalOpen, setIsRejectModalOpen] = useState(false);
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectAllUser, setSelectAllUser] = useState(true);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isUserModalDropdownOpen, setIsUserModalDropdownOpen] = useState(false);
  const [userStatusFilter, setUserStatusFilter] = useState("Active");
  const [isUserStatusDropdownOpen, setIsUserStatusDropdownOpen] = useState(false);
  const [isUserStatusModalDropdownOpen, setIsUserStatusModalDropdownOpen] = useState(false);
  const [userDropdownSearchTerm, setUserDropdownSearchTerm] = useState('');
  const [isStatusDropdownOpen, setIsStatusDropdownOpen] = useState(false);
  const [isStatusModalDropdownOpen, setIsStatusModalDropdownOpen] = useState(false);
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [userSearchTerm, setUserSearchTerm] = useState('');
  const [leaveTypeDropdownOpen, setLeaveTypeDropdownOpen] = useState(false);
  const [startTimeDropdownOpen, setStartTimeDropdownOpen] = useState(false);
  const [endTimeDropdownOpen, setEndTimeDropdownOpen] = useState(false);
  const [showingDropdownOpen, setShowingDropdownOpen] = useState(false);
  const [userId, setUserId] = useState("");
  const [typeOfLeave, setTypeOfLeave] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [uploadDocument, setUploadDocument] = useState(null);
  const [note, setNote] = useState("");
  const [editRowData, setEditRowData] = useState("");
  const [selectedEditId, setSelectedEditId] = useState("");
  const [userIdEdit, setUserIdEdit] = useState("");
  const [typeOfLeaveEdit, setTypeOfLeaveEdit] = useState("");
  const [startTimeEdit, setStartTimeEdit] = useState("");
  const [endTimeEdit, setEndTimeEdit] = useState("");
  const [uploadDocumentEdit, setUploadDocumentEdit] = useState(null);
  const [uploadDocumentEditName, setUploadDocumentEditName] = useState(null);
  const [noteEdit, setNoteEdit] = useState("");
  const [status, setStatus] = useState(null);
  const [leaveTypeEditIsValid, setLeaveTypeEditIsValid] = useState(false);
  const leaveTypeEditRef = useRef(null);
  const [userEditIsValid, setUserEditIsValid] = useState(false);
  const userEditRef = useRef(null);
  const [dateRangeEditIsValid, setDateRangeEditIsValid] = useState(false);
  const dateRangeEditRef = useRef(null);
  const [startTimeEditIsValid, setStartTimeEditIsValid] = useState(false);
  const startTimeEditRef = useRef(null);
  const [endTimeEditIsValid, setEndTimeEditIsValid] = useState(false);
  const endTimeEditRef = useRef(null);
  const [noteEditIsValid, setNoteEditIsValid] = useState(false);
  const noteEditRef = useRef(null);
  const [documentEditIsValid, setDocumentEditIsValid] = useState(false);
  const documentEditRef = useRef(null);
  const [dateRangeEdit, setDateRangeEdit] = useState([new Date(), new Date()]);
  const [dateRangeTypeEdit, setDateRangeTypeEdit] = useState("");
  const handleSelectEdit = (ranges) => {
    setDateRangeEdit(ranges);

    if (ranges !== null) {
      if (moment(ranges[0]).tz(global.config.getTimeZone()).format("X") === moment(ranges[1]).tz(global.config.getTimeZone()).format("X")) {
        setDateRangeTypeEdit('single');
      } else {
        setDateRangeTypeEdit('multiple');
      }
    }
  };
  const targetRef = useRef(null);
  const userDropdownRef = useRef(null);
  const userModalDropdownRef = useRef(null);
  const userStatusDropdownRef = useRef(null);
  const userStatusModalDropdownRef = useRef(null);
  const statusDropdownRef = useRef(null);
  const statusModalDropdownRef = useRef(null);
  const userSelectDropdownRef = useRef(null);
  const leaveTypeSelectDropdownRef = useRef(null);
  const startTimeDropdownRef = useRef(null);
  const endTimeDropdownRef = useRef(null);
  const showingDropdownRef = useRef(null);
  const calendarRef = useRef(null);
  const modalCalendarRef = useRef(null);
  const { appSettings } = useSelector((state) => state.appSettings);
  const tz = useSelector((state) => state.appSettings.appSettings?.appTimeZone || state.appSettings.appSettings?.timeZone);
  const [currentPage, setCurrentPage] = useState(1);
  const [dateRange, setDateRange] = useState([new Date(), new Date()]);
  const [dateRangeType, setDateRangeType] = useState("");
  const handleSelect = (ranges) => {
    setDateRange(ranges);
    if (ranges !== null) {
      if (moment(ranges[0]).tz(global.config.getTimeZone()).format("X") === moment(ranges[1]).tz(global.config.getTimeZone()).format("X")) {
        setDateRangeType('single');
      } else {
        setDateRangeType('multiple');
      }
    }
  };
  const [leaveTypeIsValid, setLeaveTypeIsValid] = useState(false);
  const leaveTypeRef = useRef(null);
  const [userIsValid, setUserIsValid] = useState(false);
  const userRef = useRef(null);
  const [dateRangeIsValid, setDateRangeIsValid] = useState(false);
  const dateRangeRef = useRef(null);
  const [startTimeIsValid, setStartTimeIsValid] = useState(false);
  const startTimeRef = useRef(null);
  const [endTimeIsValid, setEndTimeIsValid] = useState(false);
  const endTimeRef = useRef(null);
  const [noteIsValid, setNoteIsValid] = useState(false);
  const noteRef = useRef(null);
  const [documentIsValid, setDocumentIsValid] = useState(false);
  const documentRef = useRef(null);
  const [showCalendar, setShowCalendar] = useState(false);
  const [showModalCalendar, setShowModalCalendar] = useState(false);
  const [selectedRange, setSelectedRange] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const optionDropdownRef = useRef(null);
  const [selectedOption, setSelectedOption] = useState("Categories");
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [checkedOption, setCheckedOption] = useState(null);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const toggleFilterModal = () => {
    setShowFilterModal(!showFilterModal);
  };
  const applyFilters = () => {
    setShowFilterModal(false);
  };

  const handleApplyConfirm = () => {
    const filteredUserIds = userIds && userIds
      .filter((user) => userStatusFilter === "All" || (userStatusFilter === "Active" ? user.is_active === true : user.is_active === false))
      .map((user) => user._id);
    setSelectedRange(null);
    setSelectedUsers(filteredUserIds);
    setSelectedStatus(['Pending', 'Approved', 'Rejected', 'Cancelled']);
    setShowConfirmationModal(false);
    setShowFilterModal(false);
  };

  const clearFilters = () => {
    setSelectedRange(null);
    setUserStatusFilter("Active");
    const filteredUserIds = userIds && userIds
      .filter((user) => user.is_active === true)
      .map((user) => user._id);
    setSelectedUsers(filteredUserIds);
    setSelectedStatus(['Pending', 'Approved', 'Rejected', 'Cancelled']);
    setShowFilterModal(false);
  };
  const checkAndShowConfirmationModal = () => {
    const isCreateDateModified = !isEqual(selectedRange, null);
    const isUsersModified = !isEqual(selectedUsers, userIds.map((user) => user._id));
    const isStatusModified = !isEqual(selectedStatus, ['Pending', 'Approved', 'Rejected', 'Cancelled']);

    if (
      isUsersModified ||
      isStatusModified ||
      isCreateDateModified
    ) {
      setShowConfirmationModal(true);
    } else {
      setShowFilterModal(false);
    }

  };

  const selectSortOption = (option) => {
    setSelectedSortOption(option);
    setCheckedOption(option);
    setSortDropdownOpen(false);
  };

  const toggleSortDropdown = () => {
    setSortDropdownOpen(!sortDropdownOpen);
  };
  const onDateChange = (ranges) => {
    if (!ranges || !ranges.startDate) return;
    const dateRangeArray = [ranges.startDate, ranges.endDate];
    setSelectedRange(dateRangeArray);
    setCurrentPage(1);
    setShowCalendar(false);
    setShowModalCalendar(false);
  };

  const toggleCalendar = () => {
    setShowCalendar(!showCalendar);
  };

  const toggleModalCalendar = () => {
    setShowModalCalendar(!showModalCalendar);
  };

  const cancelCalendar = () => {
    setShowCalendar(false);
  };

  const cancelModalCalendar = () => {
    setShowModalCalendar(false);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);
    setCurrentPage(1);

    clearTimeout(filterDebounceTimeout.current);
    filterDebounceTimeout.current = setTimeout(() => {
      setFilterSearch(value);
    }, 500);
  };

  let token = null;

  const { user } = useSelector((state) => state.auth);
  if (user) {
    if (user && user.token) {
      token = user.token;
    }
  }

  const { data: userIds = [], isLoading: isLoadingUser, refetch: userIdRefetch } = useUserById(token);
  const { data: activeUser = [], isLoading: isLoadingActiveUser, refetch: activeUserRefetch } = useActiveUser(token);
  const { data: leaveType = [], isLoading: isFetchingLeaveTypes, refetch: leaveTypeRefetch } = useFetchLeaveTypes(token);

  // Fetch time off data using React Query
  const {
    data: timeOffDataResponse,
    isLoading: timeOffLoading,
    isFetching: isFetchingTimeOff,
    error: timeOffError,
    refetch: refetchTimeOff,
  } = useTimeOffRequestsOptimized({
    token,
    currentPage,
    limit: perPage,
    startDate: selectedRange?.[0] || null,
    endDate: selectedRange?.[1] || null,
    users: selectedUsers,
    status: selectedStatus,
    filter: filterSearch,
    enabled: selectedUsers.length > 0 && selectedStatus.length > 0 && !!currentPage && !!perPage,
  });

  // Extract data from response
  const timeoffDataOptimized = timeOffDataResponse?.data || [];
  const timeOffData = timeOffDataResponse?.data || [];
  const total = timeOffDataResponse?.totalCount || 0;

  // Check if query prerequisites are met
  const isQueryEnabled = selectedUsers.length > 0 && selectedStatus.length > 0 && !!currentPage && !!perPage;
  const hasDataLoaded = !!timeOffDataResponse;
  // Prerequisites loaded but selectedUsers not yet populated = transitioning between phase 1 and 2
  const isTransitioning = !isLoadingUser && !isLoadingActiveUser && !isFetchingLeaveTypes && !isQueryEnabled && !hasDataLoaded;
  // Show skeleton through both loading phases with no gap between them
  const shouldShowSkeleton = (isLoadingUser || isLoadingActiveUser || isFetchingLeaveTypes) ||
    isTransitioning ||
    (isQueryEnabled && !hasDataLoaded && (timeOffLoading || isFetchingTimeOff));

  useEffect(() => {
    const handleLoading = async () => {
      try {
        await dispatch(setAppLoading(timeOffLoading));
      } catch (error) {
        console.error("Error while updating app loading state:", error);
      }
    };

    handleLoading();
  }, [timeOffLoading]);

  const approveTimeOffRequestMutation = useApproveTimeOffRequest(token);
  const rejectTimeOffRequestMutation = useRejectTimeOffRequest(token);
  const cancelTimeOffRequestMutation = useCancelTimeOffRequest(token);
  const deleteTimeOffRequestMutation = useDeleteTimeOffRequest(token);
  const createTimeOffRequestMutation = useCreateTimeOffRequest(token);
  const updateTimeOffRequestMutation = useUpdateTimeOffRequest(token);


  useEffect(() => {
    try {
      const resizeObserver = new ResizeObserver((entries) => {
        // Your resize observer logic here
      });
      if (targetRef.current) {
        resizeObserver.observe(targetRef.current);
      }
      // Clean up the observer on component unmount
      return () => {
        if (targetRef.current) {
          resizeObserver.unobserve(targetRef.current);
        }
      };

    } catch (error) {
      console.log(error);
    }

  }, []);

  useEffect(() => {
    try {
      dispatch(setHeaderText("Time Off"));
      if ((user.userType !== 1 && user.userType !== 2)) {
        setUserId(user._id);
      }
    } catch (error) {
      console.log(error);
    }
  }, [dispatch, token, user._id, user.userType]);

  const previousFilteredUserIdsRef = useRef(null);
  const hasInitializedSelectedStatusRef = useRef(false);

  useEffect(() => {
    try {
      const arraysEqual = (a, b) => {
        if (!a || !b) return a === b;
        if (!Array.isArray(a) || !Array.isArray(b)) return a === b;
        if (a.length !== b.length) return false;
        return a.every((val, idx) => {
          if (val && typeof val === 'object' && b[idx] && typeof b[idx] === 'object') {
            return val._id === b[idx]._id;
          }
          return val === b[idx];
        });
      };

      const filteredUserIds = userIds && userIds
        .filter((user) => userStatusFilter === "All" || (userStatusFilter === "Active" ? user.is_active === true : user.is_active === false))
        .map((user) => user._id);

      const filteredUserIdsChanged = !arraysEqual(previousFilteredUserIdsRef.current, filteredUserIds);
      if (filteredUserIdsChanged) {
        setSelectedUsers(filteredUserIds || []);
        previousFilteredUserIdsRef.current = filteredUserIds;
      }

      if (!hasInitializedSelectedStatusRef.current) {
        setSelectedStatus(['Pending', 'Approved', 'Rejected', 'Cancelled']);
        hasInitializedSelectedStatusRef.current = true;
      }
    } catch (error) {
      console.log(error);
    }
  }, [userIds, userStatusFilter]);

  const handleToggleUserDropdown = () => {
    try {
      setUserSearchTerm('');
      setUserDropdownOpen((prevOpen) => !prevOpen);
    } catch (error) {
      console.log(error);
    }
  };


  const handleSelectUser = (selectedUserId) => {
    try {
      setUserId(selectedUserId);
      setUserSearchTerm('');
      setUserDropdownOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectUserEdit = (selectedUserId) => {
    try {
      setUserIdEdit(selectedUserId);
      setUserSearchTerm('');
      setUserDropdownOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleUserSearchInputChange = (e) => {
    setUserSearchTerm(e.target.value);
  };

  let filteredUsers = [];

  try {
    filteredUsers = activeUser.filter((user) => {
      const fullName = user.first_name
        ? `${user.first_name} ${user.middle_name || ''} ${user.last_name || ''}`.trim()
        : `${user.company_first_name || ''} ${user.company_last_name || ''}`.trim() || user.company_name || '';

      return fullName.toLowerCase().includes(userSearchTerm?.toLowerCase() || '');
    });
  } catch (error) {
    console.error("Error while filtering users:", error);
    filteredUsers = []; // fallback to empty array if error occurs
  }

  const handleToggleStartTimeDropdown = () => {
    setStartTimeDropdownOpen(!startTimeDropdownOpen);
  };

  const handleToggleEndTimeDropdown = () => {
    setEndTimeDropdownOpen(!endTimeDropdownOpen);
  };

  const handleCheckboxStatusChange = (status) => {
    try {
      const updatedStatusSelection = [...selectedStatus];
      const index = updatedStatusSelection.indexOf(status);

      if (index === -1) {
        // Add to selection
        updatedStatusSelection.push(status);
      } else {
        // Remove from selection
        updatedStatusSelection.splice(index, 1);
      }

      setCurrentPage(1);
      setSelectedStatus(updatedStatusSelection);
    } catch (error) {
      console.error("Error updating checkbox status selection:", error);
      // Optional: You can show a toast or alert here
    }
  };


  const handleCheckboxUserChange = (userId) => {
    try {
      const updatedSelection = [...selectedUsers];
      const index = updatedSelection.indexOf(userId);

      if (index === -1) {
        // Add to selection
        updatedSelection.push(userId);
      } else {
        // Remove from selection
        updatedSelection.splice(index, 1);
      }

      setCurrentPage(1);
      setSelectedUsers(updatedSelection);
    } catch (error) {
      console.error("Error updating selected users:", error);
      // Optionally display error to user, e.g. toast("Failed to update selection")
    }
  };

  const handleSelectAllUserChange = () => {
    try {
      const filteredUserIds = userIds && userIds
        .filter((user) =>
          userStatusFilter === "All" ||
          (userStatusFilter === "Active" ? user.is_active === true : user.is_active === false)
        )
        .map((user) => user._id);

      if (!selectAllUser) {
        setSelectedUsers(filteredUserIds);
      } else {
        setSelectedUsers([]);
      }

      setSelectAllUser(!selectAllUser);
    } catch (error) {
      console.error("Error handling select all user change:", error);
    }
  };

  let filteredDropdownUsers = [];

  try {
    filteredDropdownUsers = userIds.filter((user) => {
      const fullName = user.first_name
        ? `${user.first_name} ${user.middle_name || ''} ${user.last_name}`
        : user.company_first_name
          ? `${user.company_first_name} ${user.company_last_name || ''}`
          : user.company_name || '';

      return fullName?.toLowerCase().includes(userDropdownSearchTerm?.toLowerCase());
    });
  } catch (error) {
    console.error("Error filtering dropdown users:", error);
    filteredDropdownUsers = [];
  }

  const handleUserDropdownSearchChange = (e) => {
    setUserDropdownSearchTerm(e.target.value);
  };

  const toggleUserStatusDropdown = () => {
    setIsUserStatusDropdownOpen(!isUserStatusDropdownOpen);
    setUserSearchTerm("");
  };

  const handleUserStatusChange = (status) => {
    try {
      setUserStatusFilter(status);

      const filteredTeamIds = userIds && userIds
        .filter((user) =>
          status === "All" ? true : status === "Active" ? user.is_active === true : user.is_active === false
        )
        .map((user) => user._id);

      const updatedSelectedTeams = selectedUsers.filter((teamId) =>
        filteredTeamIds.includes(teamId)
      );

      setSelectedUsers(updatedSelectedTeams); // preserve only valid ones
      setSelectAllUser(false);
    } catch (error) {
      console.error("Error updating user status filter:", error);
      setSelectedUsers([]); // optional fallback
      setSelectAllUser(false);
    }
  };

  const toggleUserStatusModalDropdown = () => {
    setIsUserStatusModalDropdownOpen(!isUserStatusModalDropdownOpen);
    setUserSearchTerm("");
  };


  const [selectAllStatus, setSelectAllStatus] = useState(true);

  const handleSelectAllStatusChange = () => {
    try {
      if (!selectAllStatus) {
        setSelectedStatus(['Pending', 'Approved', 'Rejected', 'Cancelled']);
      } else {
        setSelectedStatus([]);
      }
      setSelectAllStatus(!selectAllStatus);
    } catch (error) {
      console.error("Error updating status selection:", error);
    }
  };

  useEffect(() => {
    try {
      const filteredTeamIds = userIds && userIds
        .filter((user) =>
          userStatusFilter === "All"
            ? true
            : userStatusFilter === "Active"
              ? user.is_active === true
              : user.is_active === false
        )
        .map((user) => user._id);

      const isAllUsersSelected = filteredTeamIds.length > 0 && selectedUsers.length === filteredTeamIds.length;
      setSelectAllUser(isAllUsersSelected);
      setUserFilter(isAllUsersSelected ? "All" : selectedUsers);

      const isAllStatusSelected = selectedStatus.length === 4;
      setSelectAllStatus(isAllStatusSelected);
      setStatusFilter(isAllStatusSelected ? "All" : selectedStatus);
    } catch (error) {
      console.error("Error in filtering users or status:", error);
    }
  }, [selectedUsers, userIds, selectedStatus]);

  const toggleUserDropdown = () => {
    setIsUserDropdownOpen(!isUserDropdownOpen);
    setUserDropdownSearchTerm("");
  };

  const toggleUserModalDropdown = () => {
    setIsUserModalDropdownOpen(!isUserModalDropdownOpen);
    setUserDropdownSearchTerm("");
  };

  const toggleStatusDropdown = () => {
    setIsStatusDropdownOpen(!isStatusDropdownOpen);
  };

  const toggleStatusModalDropdown = () => {
    setIsStatusModalDropdownOpen(!isStatusModalDropdownOpen);
  };

  const handleClickOutsideDropdown = (event) => {
    try {
      const isClickInsideUserDropdown = userDropdownRef.current && userDropdownRef.current.contains(event.target);
      const isClickInsideUserModalDropdown = userModalDropdownRef.current && userModalDropdownRef.current.contains(event.target);
      const isClickInsideUserSelectDropdown = userSelectDropdownRef.current && userSelectDropdownRef.current.contains(event.target);
      const isClickInsideStatusDropdown = statusDropdownRef.current && statusDropdownRef.current.contains(event.target);
      const isClickInsideStatusModalDropdown = statusModalDropdownRef.current && statusModalDropdownRef.current.contains(event.target);
      const isClickInsideLeaveTypeSelectDropdown = leaveTypeSelectDropdownRef.current && leaveTypeSelectDropdownRef.current.contains(event.target);
      const isClickInsideStartTimeSelectDropdown = startTimeDropdownRef.current && startTimeDropdownRef.current.contains(event.target);
      const isClickInsideEndTimeSelectDropdown = endTimeDropdownRef.current && endTimeDropdownRef.current.contains(event.target);
      const isClickInsideShowingDropdown = showingDropdownRef.current && showingDropdownRef.current.contains(event.target);
      const isClickInsideCalendarDropdown = calendarRef.current && calendarRef.current.contains(event.target);
      const isClickInsideModalCalendarDropdown = modalCalendarRef.current && modalCalendarRef.current.contains(event.target);
      const isClickInsideUserStatusDropdown = userStatusDropdownRef.current && userStatusDropdownRef.current.contains(event.target);
      const isClickInsideUserStatusModaDropdown = userStatusModalDropdownRef.current && userStatusModalDropdownRef.current.contains(event.target);

      if (!isClickInsideUserDropdown) setIsUserDropdownOpen(false);
      if (!isClickInsideUserModalDropdown) setIsUserModalDropdownOpen(false);
      if (!isClickInsideStatusDropdown) setIsStatusDropdownOpen(false);
      if (!isClickInsideStatusModalDropdown) setIsStatusModalDropdownOpen(false);
      if (!isClickInsideUserSelectDropdown) setUserDropdownOpen(false);
      if (!isClickInsideLeaveTypeSelectDropdown) setLeaveTypeDropdownOpen(false);
      if (!isClickInsideStartTimeSelectDropdown) setStartTimeDropdownOpen(false);
      if (!isClickInsideEndTimeSelectDropdown) setEndTimeDropdownOpen(false);
      if (!isClickInsideShowingDropdown) setShowingDropdownOpen(false);
      if (!isClickInsideCalendarDropdown) setShowCalendar(false);
      if (!isClickInsideModalCalendarDropdown) setShowModalCalendar(false);
      if (!isClickInsideUserStatusDropdown) setIsUserStatusDropdownOpen(false);
      if (!isClickInsideUserStatusModaDropdown) setIsUserStatusModalDropdownOpen(false);
    } catch (error) {
      console.error("Error in handleClickOutsideDropdown:", error);
    }
  };

  useEffect(() => {
    try {
      document.addEventListener('click', handleClickOutsideDropdown);
    } catch (error) {
      console.error("Error attaching click listener:", error);
    }

    return () => {
      try {
        document.removeEventListener('click', handleClickOutsideDropdown);
      } catch (error) {
        console.error("Error removing click listener:", error);
      }
    };
  }, []);




  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Generate pagination pages with ellipsis
  const getPaginationPages = () => {
    const pages = [];
    const maxVisiblePages = 3; // Show max 3 page numbers at a time (excluding first/last)

    if (totalPages <= maxVisiblePages + 2) {
      // If total pages is small, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      // Always show first page
      pages.push(1);

      // Calculate start and end of visible range around current page
      let startPage = Math.max(2, currentPage - 1);
      let endPage = Math.min(totalPages - 1, currentPage + 1);

      // Adjust range if we're near the beginning or end
      if (currentPage <= 2) {
        endPage = Math.min(4, totalPages - 1);
      } else if (currentPage >= totalPages - 1) {
        startPage = Math.max(totalPages - 3, 2);
      }

      // Add ellipsis before visible range if needed
      if (startPage > 2) {
        pages.push('ellipsis-start');
      }

      // Add visible pages
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      // Add ellipsis after visible range if needed
      if (endPage < totalPages - 1) {
        pages.push('ellipsis-end');
      }

      // Always show last page
      pages.push(totalPages);
    }

    return pages;
  };
  const handleOpenCreateModal = () => {
    if ((user.userType !== 1 && user.userType !== 2)) {
      setUserId(user._id);
    }
    setIsCreateModalOpen(true);
  };

  const handleCloseCreateModal = () => {
    setIsCreateModalOpen(false);
    setUserId("");
    setTypeOfLeave("");
    setStartTime("");
    setEndTime("");
    setDateRange(null);
    setUploadDocument(null);
    setNote("");
    setUserIsValid(false);
    setLeaveTypeIsValid(false);
    setDateRangeIsValid(false);
    setStartTimeIsValid(false);
    setEndTimeIsValid(false);
    setDocumentIsValid(false);
    setNoteIsValid(false);
  };

  const handleOpenDetailsModal = (item) => {
    setSelectedId(item._id);
    setEditRowData(item);
    setIsDetailsModalOpen(true);
  };

  const handleApprove = () => {
    setIsApproveModalOpen(true);
  };

  const handleConfirmApprove = async () => {
    try {
      setIsSubmitLoading(true);

      const response = await approveTimeOffRequestMutation.mutateAsync(selectedId);

      // Check if the response contains the expected data
      if (response) {
        toast.success("Time Off request approved successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Time Off "${selectedId}" request Approved successfully!`
        );
        dispatch(setNotification(Date.now()));
      }

      handleCloseDetailsModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response.data.status === "mailfailed") {
        toast.error("TOR approved but something went wrong in sending mail!!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Time Off "${selectedId}" request Approved successfully but something went wrong in sending Mail!!!`
        );
        handleCloseDetailsModal();
      } else if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      } else {
        toast.error("Something went wrong in approval!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Something went wrong while Approving Time Off "${selectedId}"!!!`
        );
        console.log(error);
      }
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleCancelApprove = () => {
    setIsApproveModalOpen(false);
  };

  const handleReject = () => {
    setIsRejectModalOpen(true);
  };

  const handleConfirmReject = async (id) => {
    try {
      setIsSubmitLoading(true);
      await rejectTimeOffRequestMutation.mutateAsync(selectedId);
      toast.success("Time-Off request rejected successfully!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Time Off",
        `Time Off "${selectedId}" request rejected successfully!`
      );
      dispatch(setNotification(Date.now()));
      handleCloseDetailsModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response.data.status === "mailfailed") {
        toast.error("TOR rejected but something went wrong in sending mail!!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Time Off "${selectedId}" request rejected successfullybut Something went wrong in sending Mail!!!`
        );
        handleCloseDetailsModal();
      } else if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      } else {
        toast.error("Something went wrong in TOR rejection!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Something went wrong while rejecting Time Off "${selectedId}" request!!!`
        );
        console.log(error);
      }
    } finally {
      setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
    }
  };

  const handleCancelReject = () => {
    setIsRejectModalOpen(false);
  };

  const handleCancel = () => {
    setIsCancelModalOpen(true);
  };

  const handleConfirmCancel = async (id) => {
    try {
      setIsSubmitLoading(true);
      await cancelTimeOffRequestMutation.mutateAsync(selectedId);
      toast.success("Time-Off request cancelled successfully!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Time Off",
        `Time Off "${selectedId}" request cancelled successfully!`
      );
      dispatch(setNotification(Date.now()));
      handleCloseDetailsModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response.data.status === "mailfailed") {
        toast.error("TOR cancelled but something went wrong in sending mail!!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Time Off "${selectedId}" request cancelled successfully but Something went wrong in sending Mail!!!`
        );
        handleCloseDetailsModal();
      } else if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      } else {
        toast.error("Something went wrong in TOR cancelation!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Something went wrong while Canceling Time Off "${selectedId}" request!!!`
        );
        console.log(error);
      }
    } finally {
      setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
    }
  };

  const handleCancelCancel = () => {
    setIsCancelModalOpen(false);
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };
  const handleEdit = () => {
    try {
      setIsDetailsModalOpen(false);
      setSelectedEditId(selectedId);

      if (editRowData?.userDetails?._id) {
        setUserIdEdit(editRowData.userDetails._id);
      }

      if (editRowData?.leaveDetails?._id) {
        setTypeOfLeaveEdit(editRowData.leaveDetails._id);
      }

      if (editRowData?.start_date && editRowData?.end_date) {
        setDateRangeEdit([
          new Date(editRowData.start_date),
          new Date(editRowData.end_date),
        ]);

        const startTimestamp = moment(editRowData.start_date)
          .tz(global.config.getTimeZone())
          .format("X");

        const endTimestamp = moment(editRowData.end_date)
          .tz(global.config.getTimeZone())
          .format("X");

        if (startTimestamp === endTimestamp) {
          setStartTimeEdit(editRowData.start_time || "");
          setEndTimeEdit(editRowData.end_time || "");
          setDateRangeTypeEdit("single");
        } else {
          setStartTimeEdit("");
          setEndTimeEdit("");
          setDateRangeTypeEdit("multiple");
        }
      }

      setUploadDocumentEditName(editRowData?.timeoff_document || null);
      setNoteEdit(editRowData?.note || "");
      setIsEditModalOpen(true);
    } catch (error) {
      console.error("Error in handleEdit:", error);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      setIsSubmitLoading(true);
      await deleteTimeOffRequestMutation.mutateAsync(selectedId);

      toast.success("TimeOff request removed successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(window.location.href, 'Time Off', `Time Off request (${selectedId}) deleted successfully`);
      dispatch(setNotification(Date.now()));
      handleCloseDetailsModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(window.location.href, 'Time Off', `Something went wrong while deleting Time Off request (${selectedId})`);
    } finally {
      setIsSubmitLoading(false); // Set isLoading to false after the approval process is complete
    }
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };
  const handleCloseEditModal = () => {
    try {
      setIsEditModalOpen(false);
      setSelectedEditId("");
      setUserIdEdit("");
      setTypeOfLeaveEdit("");
      setDateRangeEdit(null);
      setStartTimeEdit("");
      setEndTimeEdit("");
      setDateRangeTypeEdit('single');
      setUploadDocumentEditName("");
      setNoteEdit("");
    } catch (error) {
      console.error("Error while closing the edit modal:", error);
    }
  };

  const handleCloseDetailsModal = () => {
    try {
      setIsDetailsModalOpen(false);
      setIsApproveModalOpen(false);
      setIsRejectModalOpen(false);
      setIsCancelModalOpen(false);
      setIsDeleteModalOpen(false);
      setUserId("");
      setProfilePhoto("");
      setProfileName("");
      setIssueDate("");
      setTotalHours("");
      setStartDate("");
      setEndDate("");
      setTorStatus("");
      setTypeOfLeave("");
      setStartTime("");
      setEndTime("");
      setDateRange(null);
      setUploadDocument(null);
      setNote("");
      setVerifiedByProfilePhoto("");
      setVerifiedByProfileName("");
      setEditRowData("");
    } catch (error) {
      console.error("Error while closing the details modal:", error);
    }
  };

  const ranges = [
    {
      label: "today",
      value: [new Date(), new Date()],
    },
    {
      label: "yesterday",
      value: [subDays(new Date(), 1), subDays(new Date(), 1)],
    },
  ];

  const calculateNumberOfDays = (startDate, startTime, endDate, endTime) => {
    try {
      if (!startTime || !endTime || startDate !== endDate) {
        const startDateTime = moment(startDate).tz(global.config.getTimeZone()).startOf('day');
        const endDateTime = moment(endDate).tz(global.config.getTimeZone()).startOf('day');
        const duration = moment.duration(endDateTime.diff(startDateTime));
        const numberOfDays = Math.ceil(duration.asDays());
        return `${numberOfDays + 1} days`;
      } else {
        const startDateTime = moment(startDate).tz(global.config.getTimeZone()).startOf('day').add(startTime, 'hours');
        const endDateTime = moment(endDate).tz(global.config.getTimeZone()).startOf('day').add(endTime, 'hours');
        const duration = moment.duration(endDateTime.diff(startDateTime));
        const numberOfDays = Math.ceil(duration.asDays());

        if (numberOfDays === 1) {
          const numberOfHours = (endTime - startTime) * numberOfDays;
          const numberOfDaysDecimal = (numberOfHours / 8).toFixed(2);
          const cappedNumberOfDaysDecimal = Math.min(numberOfDaysDecimal, 1);
          return `${cappedNumberOfDaysDecimal} days`;
        } else {
          return `${numberOfDays} days`;
        }
      }
    } catch (error) {
      console.error("Error calculating number of days:", error);
      return "0 days";
    }
  };

  const excelTimeConverter = (time) => {
    try {
      if (typeof time !== 'number' || isNaN(time)) {
        throw new Error("Invalid time format. Expected a number.");
      }

      let hour = parseInt(time);
      let hours = hour;
      let minute = Math.round((time - hour) * 60);

      if (hour > 12) {
        hour -= 12;
      }

      if (minute === 0) {
        minute = "0";
      }

      const formattedHour = hour < 10 ? "0" + hour : hour;
      const formattedMinute = minute < 10 ? "0" + minute : minute;
      const period = hours < 12 ? "am" : "pm";

      return `${formattedHour}:${formattedMinute} ${period}`;
    } catch (error) {
      console.error("Error in excelTimeConverter:", error.message);
      return "--:--";
    }
  };

  const allowedExtensions = ["pdf", "doc", "docx", "msword", "xls", "xlsx", "csv"];
  const handleUploadDocChange = (event) => {
    try {
      const selectedFile = event.target.files?.[0];
      setDocumentIsValid(false);

      if (selectedFile) {
        const fileExtension = selectedFile.name.split(".").pop()?.toLowerCase();

        if (allowedExtensions.includes(fileExtension)) {
          setUploadDocument(selectedFile);
        } else {
          setDocumentIsValid(true);
          if (documentRef && documentRef.current) {
            documentRef.current.focus();
          }

          toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.", {
            position: "bottom-right",
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          // Optionally, clear the input
          event.target.value = null;
        }
      }
    } catch (error) {
      console.error("Error while uploading document:", error);
      toast.error("Something went wrong while processing the file.", {
        position: "bottom-right",
        autoClose: 3500,
      });
    }
  };

  const handleUploadDocEditChange = (event) => {
    try {
      const selectedFile = event.target.files?.[0];
      setDocumentEditIsValid(false);
      setUploadDocumentEditName("");

      if (selectedFile) {
        const fileExtension = selectedFile.name.split(".").pop()?.toLowerCase();

        if (allowedExtensions.includes(fileExtension)) {
          setUploadDocumentEdit(selectedFile);
        } else {
          setDocumentEditIsValid(true);
          if (documentRef && documentRef.current) {
            documentRef.current.focus();
          }

          toast.error("Invalid file format. Allowed formats are pdf, doc, docx, msword, xls, xlsx, csv.", {
            position: "bottom-right",
            autoClose: 3500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });

          // Clear the file input
          event.target.value = null;
        }
      }
    } catch (error) {
      console.error("Error while uploading edit document:", error);
      toast.error("Something went wrong while processing the file.", {
        position: "bottom-right",
        autoClose: 3500,
      });
    }
  };

  const handleTimeOffSubmit = async (event) => {
    event.preventDefault();
    setUserIsValid(false);
    setLeaveTypeIsValid(false);
    setDateRangeIsValid(false);
    setStartTimeIsValid(false);
    setEndTimeIsValid(false);
    setDocumentIsValid(false);
    setNoteIsValid(false);
    if (
      typeOfLeave === "" ||
      userId === "" ||
      dateRange === null ||
      note === ""
    ) {

      if (userId === "") {
        setUserIsValid(true);
        userRef && userRef.current.focus();
        return;
      } else if (typeOfLeave === "") {
        setLeaveTypeIsValid(true);
        leaveTypeRef && leaveTypeRef.current.focus();
        return;
      } else if (dateRange === null) {
        setDateRangeIsValid(true);
        dateRangeRef && dateRangeRef.current?.scrollIntoView({ behavior: "smooth" });
        return;
      } else if (
        moment(dateRange[0]).tz(global.config.getTimeZone()).format("X") === moment(dateRange[1]).tz(global.config.getTimeZone()).format("X")
      ) {
        if (startTime === "") {
          setStartTimeIsValid(true);
          startTimeRef && startTimeRef.current.focus();
          return;
        } else if (endTime === "") {
          setEndTimeIsValid(true);
          endTimeRef && endTimeRef.current.focus();
          return;
        }
      } else if (note === "") {
        setNoteIsValid(true);
        noteRef && noteRef.current.focus();
        return;
      }

      toast.error("Please fill all required fields!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    if (moment(dateRange[0]).tz(global.config.getTimeZone()).format("X") === moment(dateRange[1]).tz(global.config.getTimeZone()).format("X")) {
      if (startTime === endTime) {
        toast.error("Start time and End time should'nt be same!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        endTimeRef.current.focus();
        return;
      } else if (startTime && endTime && parseFloat(startTime) >= parseFloat(endTime)) {
        toast.error("Start time should be less than End time!!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setStartTimeIsValid(true);
        setEndTimeIsValid(true);
        endTimeRef.current.focus();
        return;
      } else if (startTime === "") {
        setStartTimeIsValid(true);
        startTimeRef.current.focus();
        return;
      } else if (endTime === "") {
        setEndTimeIsValid(true);
        endTimeRef.current.focus();
        return;
      }
    }

    const requestData = {
      type_of_leave: typeOfLeave,
      user: userId,
      start_date: dateRange[0],
      end_date: dateRange[1],
      start_time: startTime,
      end_time: endTime,
      note,
      appId: appSettings && appSettings.appId,
      timeZone: tz,
    };

    const formData = new FormData();
    formData.append("timeoff_document", uploadDocument);

    // Append the other request data to the form data
    for (let key in requestData) {
      formData.append(key, requestData[key]);
    }
    try {
      setIsSubmitLoading(true);
      await createTimeOffRequestMutation.mutateAsync(formData);
      global.config.activityLog(
        window.location.href,
        "Time of request",
        `Time Off request for (${userId}) created successfully`
      );
      toast.success("Time-Off request added successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch(setNotification(Date.now()));
      handleCloseCreateModal();
      // }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response.data.status === "mailfailed") {
        toast.error("Time Off Request added successfully but Something went wrong in sending mail!!", {
          position: "bottom-right",
          autoClose: 3500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(window.location.href, 'Time Off', `Time Off request for (${userId}) created successfully but Something went wrong in sending Mail!!`);

        handleCloseCreateModal();
      } else if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error('This user is deleted!', {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      } else {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleTimeOffEditSubmit = async (event) => {
    try {
      event.preventDefault();
      setUserEditIsValid(false);
      setLeaveTypeEditIsValid(false);
      setDateRangeEditIsValid(false);
      setStartTimeEditIsValid(false);
      setEndTimeEditIsValid(false);
      setDocumentEditIsValid(false);
      setNoteEditIsValid(false);

      if (
        typeOfLeaveEdit === "" ||
        userIdEdit === "" ||
        dateRangeEdit === null ||
        noteEdit === ""
      ) {
        if (userIdEdit === "") {
          setUserEditIsValid(true);
          userRef?.current?.focus();
          return;
        } else if (typeOfLeaveEdit === "") {
          setLeaveTypeEditIsValid(true);
          leaveTypeEditRef?.current?.focus();
          return;
        } else if (dateRangeEdit === null) {
          setDateRangeEditIsValid(true);
          dateRangeEditRef?.current?.scrollIntoView({ behavior: "smooth" });
          return;
        } else if (noteEdit === "") {
          setNoteEditIsValid(true);
          noteRef?.current?.focus();
          return;
        }

        toast.error("Please fill all required fields!", {
          position: "bottom-right",
          autoClose: 2000,
        });
        return;
      }

      if (
        moment(dateRangeEdit[0]).tz(global.config.getTimeZone()).format("X") ===
        moment(dateRangeEdit[1]).tz(global.config.getTimeZone()).format("X")
      ) {
        if (startTimeEdit === "") {
          setStartTimeEditIsValid(true);
          startTimeEditRef?.current?.focus();
          return;
        } else if (endTimeEdit === "") {
          setEndTimeEditIsValid(true);
          endTimeEditRef?.current?.focus();
          return;
        } else if (startTimeEdit === endTimeEdit) {
          toast.error("Start time and End time shouldn't be the same!", {
            position: "bottom-right",
            autoClose: 2000,
          });
          endTimeEditRef?.current?.focus();
          return;
        } else if (parseFloat(startTimeEdit) >= parseFloat(endTimeEdit)) {
          toast.error("Start time should be less than End time!", {
            position: "bottom-right",
            autoClose: 2000,
          });
          setStartTimeEditIsValid(true);
          setEndTimeEditIsValid(true);
          endTimeEditRef?.current?.focus();
          return;
        }
      }

      const requestData = {
        type_of_leave: typeOfLeaveEdit,
        user: userIdEdit,
        start_date: dateRangeEdit[0],
        end_date: dateRangeEdit[1],
        start_time: startTimeEdit,
        end_time: endTimeEdit,
        note: noteEdit,
        timeZone: tz,
      };

      const formData = new FormData();
      formData.append("timeoff_document", uploadDocumentEdit);
      for (let key in requestData) {
        formData.append(key, requestData[key]);
      }

      setIsSubmitLoading(true);
      await updateTimeOffRequestMutation.mutateAsync({ selectedId: selectedEditId, formData });

      global.config.activityLog(
        window.location.href,
        "Time Off Request",
        `Time Off request for (${userIdEdit}) updated successfully`
      );

      toast.success("Time-Off request updated successfully", {
        position: "bottom-right",
        autoClose: 2000,
      });

      dispatch(setNotification(Date.now()));
      handleCloseEditModal();

    } catch (error) {
      console.error("Error updating Time Off request:", error);
      global.config.slackMessage(error.toString());

      const status = error?.response?.data?.status;

      if (status === "mailfailed") {
        toast.error("Time Off updated, but email sending failed!", {
          position: "bottom-right",
          autoClose: 3500,
        });

        global.config.activityLog(
          window.location.href,
          "Time Off",
          `Time Off request for (${userIdEdit}) updated, but email failed`
        );

        handleCloseEditModal();

      } else if (status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());

        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
        });

        navigate("/");
        return;
      } else {
        toast.error("Something went wrong while updating Time Off!", {
          position: "bottom-right",
          autoClose: 2000,
        });
      }

    } finally {
      setIsSubmitLoading(false);
    }
  };

  const downloadTimeOffDoc = async (timeoff) => {
    try {
      const response = await axios.get(`/api/time-off/download/${timeoff}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      saveAs(pdfBlob, `${timeoff}`);
    } catch (error) {
      console.error(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      // Handle error
    }
  };

  const exportToExcel = () => {
    if (timeOffData.length === 0) {
      toast.error("No data to export.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }
    try {
      const now = new Date();
      const formattedDate =
        now.getFullYear() +
        "-" +
        (now.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        now.getDate().toString().padStart(2, "0");
      const formattedTime =
        now.getHours().toString().padStart(2, "0") +
        ":" +
        now.getMinutes().toString().padStart(2, "0") +
        ":" +
        now.getSeconds().toString().padStart(2, "0");

      const modifiedLog = timeOffData.map((item, index) => ({
        "User": item.userDetails
          ? item.userDetails.first_name
            ? `${item.userDetails.first_name} ${item.userDetails.middle_name ? item.userDetails.middle_name : ''} ${item.userDetails.last_name ? item.userDetails.last_name : ''}`
            : item.userDetails.company_first_name
              ? `${item.userDetails.company_first_name} ${item.userDetails.company_last_name ? item.userDetails.company_last_name : ''}`
              : item.userDetails.company_name
          : '',
        "Type": item.leaveDetails
          ? item.leaveDetails.leave_type
          : '',

        "Days Filed Before Leave": item.created_at ? calculateDaysBetweenDates(item.created_at, item.start_date) : "",
        "Issue Date": item.created_at ? moment.tz(moment(item.created_at).format("YYYY-MM-DD"), global.config.getTimeZone()).format("DD/MM/YYYY") : "",
        "Total Days": item.start_date ? calculateNumberOfDays(item.start_date, item.start_time, item.end_date, item.end_time) : "",
        "Start Date": item.start_date ? moment.tz(moment(item.start_date).format("YYYY-MM-DD"), global.config.getTimeZone()).format("DD/MM/YYYY") : "",
        "End Date": item.end_date ? moment.tz(moment(item.end_date).format("YYYY-MM-DD"), global.config.getTimeZone()).format("DD/MM/YYYY") : "",
        "Start Time": item.start_time ? excelTimeConverter(item.start_time) : excelTimeConverter(9),
        "End Time": item.end_time ? excelTimeConverter(item.end_time) : excelTimeConverter(18),
        "Status": item.status ? item.status : '',
        "Verified By": item.torVerifiedByDetails
          ? item.torVerifiedByDetails.first_name
            ? `${item.torVerifiedByDetails.first_name} ${item.torVerifiedByDetails.middle_name ? item.torVerifiedByDetails.middle_name : ''} ${item.torVerifiedByDetails.last_name ? item.torVerifiedByDetails.last_name : ''}`
            : item.torVerifiedByDetails.company_first_name
              ? `${item.torVerifiedByDetails.company_first_name} ${item.torVerifiedByDetails.company_last_name ? item.torVerifiedByDetails.company_last_name : ''}`
              : item.torVerifiedByDetails.company_name
          : 'Not Verified',
        "Remark": item.note ? item.note : '',
      }));

      const workbook = XLSX.utils.book_new();
      const worksheet = XLSX.utils.json_to_sheet(modifiedLog);
      const colWidths = [
        { wpx: 175 },
        { wpx: 110 },
        { wpx: 85 },
        { wpx: 85 },
        { wpx: 85 },
        { wpx: 85 },
        { wpx: 85 },
        { wpx: 85 },
        { wpx: 115 },
        { wpx: 175 },
        { wpx: 225 },
      ];
      worksheet["!cols"] = colWidths;
      // Add alignment to center align the first row and increase font size
      const firstRow = XLSX.utils.decode_range(worksheet["!ref"]).s.r;
      for (let i = 0; i < colWidths.length; i++) {
        const cell = XLSX.utils.encode_cell({ r: firstRow, c: i });
        const style = worksheet[cell]?.s || {};
        style.alignment = style.alignment || {};
        style.alignment.horizontal = "center !important";
        style.alignment.vertical = "center !important";
        style.font = { size: 14, bold: true };
        worksheet[cell] = { ...worksheet[cell], s: style };
      }
      // Set border for active area and increase font size
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cell = XLSX.utils.encode_cell({ r: row, c: col });
          const style = worksheet[cell]?.s || {};
          style.font = { size: 12 };
          worksheet[cell] = { ...worksheet[cell], s: style };
        }
      }
      global.config.activityLog(
        window.location.href,
        "TimeOff",
        "TimeOff exported to Excel"
      );
      const fileName = `TimeOff_Data_${formattedDate}_${formattedTime}.xlsx`;
      worksheet["!autofilter"] = { ref: range };
      XLSX.utils.book_append_sheet(workbook, worksheet, "TimeOff");
      XLSX.writeFile(workbook, fileName);
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      global.config.activityLog(
        window.location.href,
        "TimeOff",
        "Error occurred while exporting TimeOff datas to Excel"
      );
      alert("Error occurred while exporting TimeOff datas to Excel.");
    }
  };

  if (isSubmitLoading) {
    <LoadingSpinner />
  }

  const componentRef = useRef(null);
  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 }
  };

  // new table
  // total is now derived from React Query response (line 421)
  const totalPages = Math.ceil(total / perPage);
  // new table


  const calculateDaysBetweenDates = (createdAt, startDate) => {
    // Parse the dates
    const createdDate = new Date(createdAt);
    const start = new Date(startDate);

    // Check if createdAt is before startDate
    if (createdDate < start) {
      // Calculate the time difference in milliseconds
      const differenceInTime = start - createdDate;

      // Convert milliseconds to days
      const differenceInDays = Math.ceil(differenceInTime / (1000 * 60 * 60 * 24));

      return differenceInDays;
    } else {
      // If createdAt is not before startDate, return 0
      return 0;
    }
  };

  return (
    <>
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
      <motion.div
        ref={componentRef}
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        transition={{ duration: 0.3 }}
      >
        <div className="user-outer-timeoff"  >
          {(user.userType === 1 || user.userType === 2) && (
            <div className="manage manage-time-off">
              <Link to={`/user/time-off/leave-type`}>
                <span className="icon-invoice">
                  <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1143_332)">
                      <path d="M19.0704 7.87245C18.7124 7.87245 18.3983 7.6613 18.2626 7.33065L18.2304 7.25449C18.0947 6.92941 18.1709 6.55604 18.4255 6.30093C19.1789 5.54799 19.1733 4.32322 18.4255 3.57585L17.4281 2.57895C16.702 1.85263 15.4444 1.84768 14.7121 2.5678L14.7009 2.57895C14.4463 2.82786 14.0721 2.90402 13.7525 2.76842L13.6763 2.73622C13.3454 2.60619 13.1342 2.28607 13.1342 1.92879C13.1342 0.866873 12.2668 0 11.2044 0H9.78936C8.72688 0 7.85954 0.866873 7.85954 1.92879C7.85954 2.28669 7.64828 2.60619 7.32303 2.73622L7.25241 2.76842C6.92716 2.90402 6.55359 2.83344 6.29834 2.57895C5.545 1.83158 4.32516 1.83158 3.57182 2.57895L2.57438 3.57585C1.82104 4.32879 1.82104 5.54799 2.57438 6.3065C2.82901 6.56099 2.89963 6.92941 2.76396 7.26006L2.7367 7.33065C2.6066 7.6613 2.28631 7.87245 1.92884 7.87245C0.866357 7.87245 -0.000976562 8.73932 -0.000976562 9.80124V11.2099C-0.000976562 12.2774 0.866357 13.1387 1.91831 13.1387C2.27639 13.1387 2.59049 13.3498 2.72617 13.6749L2.75838 13.7511C2.89406 14.0762 2.81786 14.4495 2.56323 14.7046C1.81485 15.4576 1.81485 16.6824 2.56881 17.4297L3.57182 18.4266C4.32516 19.1746 5.545 19.1746 6.29834 18.4211C6.54739 18.1721 6.92158 18.096 7.24683 18.2316L7.31746 18.2638C7.64828 18.3938 7.85954 18.7139 7.85954 19.0712C7.85954 20.1331 8.72688 21 9.78936 21H11.2044C12.2668 21 13.1342 20.1387 13.1391 19.0656C13.1391 18.7077 13.3504 18.3938 13.6812 18.2582C13.6868 18.2582 13.7518 18.231 13.7518 18.231C14.0771 18.0954 14.4513 18.1715 14.7003 18.4204L14.7115 18.4316C15.4376 19.1523 16.7008 19.1467 17.4275 18.4204L18.4249 17.4235C19.1782 16.6762 19.1782 15.457 18.4249 14.6985C18.1759 14.4495 18.0996 14.0755 18.2353 13.7505L18.2626 13.6799C18.3983 13.3492 18.713 13.1381 19.0704 13.1381C20.1329 13.1381 21.0003 12.2712 21.0003 11.2093V9.80062C21.0003 8.7387 20.1329 7.87183 19.0704 7.87183V7.87245ZM19.965 11.2037C19.965 11.6861 19.5692 12.0817 19.0866 12.0817C18.2948 12.0817 17.596 12.5529 17.3029 13.2793L17.2757 13.3443C16.9721 14.065 17.1351 14.8885 17.6932 15.4464C18.0346 15.7932 18.0346 16.3461 17.6932 16.6873L16.6958 17.6842C16.3538 18.0254 15.7956 18.0254 15.4543 17.6842L15.4431 17.6731C14.8905 17.1257 14.0666 16.9684 13.351 17.2669L13.5517 17.7492L13.286 17.2885C12.5599 17.5814 12.0878 18.2805 12.0878 19.0712C12.0878 19.5536 11.6919 19.9492 11.2093 19.9492H9.79431C9.31171 19.9492 8.91583 19.5591 8.91583 19.0712C8.91583 18.2854 8.44995 17.587 7.72325 17.2941L7.6582 17.2669C7.41968 17.1641 7.16506 17.1152 6.91539 17.1152C6.41667 17.1152 5.92911 17.3158 5.57102 17.6842C5.22904 18.0254 4.67085 18.0254 4.32949 17.6842L3.33206 16.6873C2.99008 16.3461 2.99008 15.7882 3.33764 15.4415C3.89025 14.8892 4.05319 14.065 3.74962 13.3449L3.72236 13.2799C3.42437 12.5591 2.72493 12.0879 1.93875 12.0879C1.45614 12.0879 1.06027 11.6923 1.06027 11.2099V9.80124C1.06027 9.31889 1.45057 8.92322 1.93875 8.92322C2.72493 8.92322 3.42437 8.45201 3.72236 7.7257L3.74962 7.66625C4.05319 6.94551 3.89025 6.12198 3.33206 5.56409C2.9907 5.21734 2.9907 4.6644 3.33206 4.32322L4.32949 3.32632C4.67147 2.98514 5.22966 2.98514 5.57102 3.32632C6.12426 3.88421 6.9476 4.04706 7.6743 3.74365L7.73378 3.72198C8.4549 3.42415 8.92636 2.72508 8.92636 1.93932C8.92636 1.45697 9.32224 1.0613 9.80485 1.0613H11.2198C11.7024 1.0613 12.0983 1.45139 12.0983 1.93932C12.0983 2.72508 12.5642 3.42353 13.2909 3.71641L13.5077 3.23406L13.356 3.73808C14.0771 4.03591 14.8955 3.87864 15.4481 3.33189L15.4592 3.32074C15.8012 2.97957 16.3594 2.97957 16.7008 3.32074L17.6982 4.31765C18.0402 4.65944 18.0402 5.21176 17.6926 5.55851C17.1394 6.11641 16.9771 6.93498 17.2751 7.65511L17.3023 7.72012C17.6003 8.44582 18.2998 8.91765 19.0859 8.91765C19.5685 8.91765 19.9644 9.31331 19.9644 9.79567V11.2043L19.965 11.2037Z" fill="#6A7988" />
                      <path d="M10.4949 5.60248C7.79011 5.60248 5.58398 7.80743 5.58398 10.5108C5.58398 13.2142 7.78453 15.4192 10.4949 15.4192C13.2054 15.4192 15.4065 13.2142 15.4059 10.5108C15.4059 7.80743 13.1998 5.60248 10.4949 5.60248ZM10.4949 14.3635C8.36998 14.3635 6.63532 12.6297 6.63532 10.5059C6.63532 8.38204 8.36441 6.6483 10.4949 6.6483C12.6255 6.6483 14.3546 8.38204 14.3546 10.5059C14.3546 12.6297 12.6199 14.3635 10.4949 14.3635Z" fill="#6A7988" />
                    </g>
                    <defs>
                      <clipPath id="clip0_1143_332">
                        <rect width="21" height="21" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </span>
                Manage Categories
              </Link>
            </div>
          )}
          <div className="invoice-top">
            <div className="button-sec-invoice">

              <Link to={`/user/time-off/create`} className="btn-forpop-initem">
                <span className="icon-invoice">
                  <img src={PlusIcon} alt="Request Time Off" />
                </span>
                New Request
              </Link>
              {/* </a> */}
              <Modal
                className="client-modal sprint-modal time-off-close"
                isOpen={isCreateModalOpen}
                onRequestClose={!isSubmitLoading ? handleCloseCreateModal : undefined}
                contentLabel="Request Time Off"
                style={{
                  content: {
                    height: "41%",
                    width: "30%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    parent: document.querySelector(".admin-outer.time.tracker"),
                  },
                }}
              >
                <div className="modal timeoff-modal">
                  <div className="modal-close-invite outter-modal-main">
                    <a className="" onClick={handleCloseCreateModal} disabled={isSubmitLoading}>
                      <img src={crssrImage} alt="Edit Icon" />{" "}
                    </a>
                  </div>
                  <div className="modal-client-head 567">
                    <h2 className="">Time Off Request</h2>
                  </div>
                  <div className="form-field-client-outer">
                    <form onSubmit={handleTimeOffSubmit}>

                      {(user.userType === 1 || user.userType === 2) && (
                        <div className="form-field-client">
                          <label htmlFor="client" className="form-label">
                            User
                          </label>
                          <div ref={userSelectDropdownRef} className={`cursor ${userDropdownOpen ? 'open' : ''}`} >
                            <span
                              id="user-select"
                              onClick={handleToggleUserDropdown}
                              className={`custom-dropdown-user-new custom-dropdown-user ${userIsValid ? 'input-validation-error' : ''}`}
                              ref={userRef}
                            >
                              {userId ? (
                                activeUser?.find((user) => user._id === userId)?.first_name ? (
                                  <>
                                    {activeUser?.find((user) => user._id === userId)?.first_name}{' '}
                                    {activeUser?.find((user) => user._id === userId)?.middle_name &&
                                      activeUser?.find((user) => user._id === userId)?.middle_name !== 'null'
                                      ? activeUser?.find((user) => user._id === userId)?.middle_name + ' '
                                      : ''}
                                    {activeUser?.find((user) => user._id === userId)?.last_name}{' '}
                                  </>
                                ) : (
                                  <>
                                    {activeUser.find((user) => user._id === userId)?.company_first_name
                                      ? `${activeUser.find((user) => user._id === userId)?.company_first_name} ${activeUser.find((user) => user._id === userId)?.company_last_name
                                        ? activeUser.find((user) => user._id === userId)?.company_last_name
                                        : ''
                                      }`
                                      : `${activeUser.find((user) => user._id === userId)?.company_name || ''}(Company)`}
                                  </>
                                )
                              ) : (
                                'Select User'
                              )}
                            </span>
                            {userDropdownOpen && (
                              <div className="custom-dropdown-new">
                                <input
                                  type="text"
                                  className="search-bar"
                                  placeholder="Search..."
                                  value={userSearchTerm}
                                  onChange={handleUserSearchInputChange}
                                />
                                <ul className="client-list">
                                  {filteredUsers.length > 0 &&
                                    filteredUsers
                                      .slice()
                                      .sort((a, b) => {
                                        const nameA = a.first_name
                                          ? `${a.first_name} ${a.middle_name || ''} ${a.last_name}`
                                          : `${a.company_first_name ? a.company_first_name + (a.company_last_name && a.company_last_name) : a.company_name}`;
                                        const nameB = b.first_name
                                          ? `${b.first_name} ${b.middle_name || ''} ${b.last_name}`
                                          : `${b.company_first_name ? b.company_first_name + (b.company_last_name && b.company_last_name) : b.company_name}`;
                                        return nameA.localeCompare(nameB);
                                      })
                                      .map((item) => (
                                        <li key={item._id} className={userId === item._id ? 'selected-item' : ''} onClick={() => handleSelectUser(item._id)}>
                                          {item.first_name ? (
                                            <>
                                              {item.first_name}{' '}
                                              {item.middle_name && item.middle_name !== 'null' ? item.middle_name + ' ' : ''}
                                              {item.last_name}{' '}
                                            </>
                                          ) : (
                                            <>
                                              {item.company_first_name
                                                ? `${item.company_first_name} ${item.company_last_name ? item.company_last_name : ''}`
                                                : `${item.company_name || ''}(Company)`}
                                            </>
                                          )}
                                        </li>
                                      ))
                                  }
                                </ul>
                              </div>
                            )}
                          </div>

                          {userIsValid && (
                            <span className="text-red-500 text-xs italic">
                              User needs to be selected
                            </span>
                          )}
                        </div>
                      )}
                      <div className="form-field-client">
                        <label htmlFor="client" className="form-label">
                          Type of Leave
                        </label>

                        <div
                          ref={leaveTypeSelectDropdownRef}
                          className={`cursor ${leaveTypeDropdownOpen ? 'open' : ''}`}
                        >
                          <span
                            id="user-select"
                            onClick={() => setLeaveTypeDropdownOpen(!leaveTypeDropdownOpen)}
                            className={`custom-dropdown-user-new custom-dropdown-select ${leaveTypeIsValid ? 'input-validation-error' : ''}`}
                            ref={leaveTypeRef}
                          >
                            {typeOfLeave ? leaveType.find((leave) => leave._id === typeOfLeave)?.leave_type : 'Select'}
                          </span>
                          {leaveTypeDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <ul className="leave-type-list">
                                {leaveType &&
                                  leaveType
                                    .slice()
                                    .sort((a, b) => a.leave_type?.toLowerCase().localeCompare(b.leave_type?.toLowerCase()))
                                    .map((leave) => (
                                      <li
                                        key={leave._id}
                                        className={typeOfLeave === leave._id ? 'selected-item' : ''}
                                        onClick={() => {
                                          setTypeOfLeave(leave._id);
                                          setLeaveTypeDropdownOpen(false);
                                        }}
                                      >
                                        {leave.leave_type}
                                      </li>
                                    ))}
                              </ul>
                            </div>
                          )}
                        </div>
                        {leaveTypeIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Leave Type field Cannot be empty
                          </span>
                        )}
                      </div>
                      <div className="form-field-client" >
                        <label htmlFor="projectName" className="form-label">
                          Time Off Dates
                        </label>
                        <div className="date-picker-outer date-picker-outer-all">
                          <div className="custom-picker-icon custom-picker-icon-all">
                            <svg
                              width="1em"
                              height="1em"
                              viewBox="0 0 14 14"
                              fill="currentColor"
                              aria-hidden="true"
                              focusable="false"
                              className="rs-picker-toggle-caret rs-icon"
                              aria-label="calendar"
                              data-category="legacy"
                            >
                              <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                            </svg>
                          </div>
                          <div className="custoom-icon-calender custoom-icon-calender-all">
                            <div ref={dateRangeRef}>
                              <DateRangePicker
                                showOneCalendar
                                format="dd/MM/yyyy"
                                placeholder="From - to"
                                placement="topEnd"
                                ranges={ranges}
                                className="project-calender time-off-cal"
                                value={dateRange}
                                onChange={handleSelect}
                                isoWeek={appSettings.weekStartDay === 'Monday'}
                              />
                            </div>
                          </div>
                        </div>

                        {dateRangeIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Select the range of dates you want time off
                          </span>
                        )}
                      </div>
                      {dateRangeType === "single" && (
                        <div className="form-field-client radio-sec">
                          <div className="form-field-client">
                            <label htmlFor="client" className="form-label">
                              Start Time
                            </label>

                            <div
                              className={`custom-dropdown-user-new-outer custom-dropdown-select ${startTimeDropdownOpen ? 'open' : ''
                                }`}
                              ref={startTimeDropdownRef}
                            >
                              <div
                                className="selected-option custom-dropdown-user-new"
                                onClick={handleToggleStartTimeDropdown}
                                style={{ cursor: 'pointer' }}
                                ref={startTimeRef}
                              >
                                {startTime ? timeList.find((time) => time.time_value === startTime)?.time : 'Select'}
                              </div>
                              {startTimeDropdownOpen && (
                                <div className="custom-dropdown-new">
                                  <ul className="time-list">
                                    {timeList.map((time) => (
                                      <li
                                        key={time.time_value}
                                        className={startTime === time.time_value ? 'selected-item' : ''}
                                        onClick={() => {
                                          setStartTime(time.time_value);
                                          setStartTimeDropdownOpen(false);
                                        }}
                                      >
                                        {time.time}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            {startTimeIsValid && (
                              <span className="text-red-500 text-xs italic">
                                Please select a valid start time.
                              </span>
                            )}
                          </div>
                          <div className="form-field-client">
                            <label htmlFor="client" className="form-label">
                              End Time
                            </label>

                            <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${endTimeDropdownOpen ? 'open' : ''}`} ref={endTimeDropdownRef}>
                              <div
                                className="selected-option custom-dropdown-user-new"
                                onClick={handleToggleEndTimeDropdown}
                                style={{ cursor: 'pointer' }}
                                ref={endTimeRef}
                              >
                                {endTime ? timeList.find((time) => time.time_value === endTime)?.time : 'Select'}
                              </div>
                              {endTimeDropdownOpen && (
                                <div className="custom-dropdown-new">
                                  <ul className="time-list">
                                    {timeList.map((time) => (
                                      <li
                                        key={time.time_value}
                                        className={endTime === time.time_value ? 'selected-item' : ''}
                                        onClick={() => {
                                          setEndTime(time.time_value);
                                          setEndTimeDropdownOpen(false);
                                        }}
                                      >
                                        {time.time}
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              )}
                            </div>
                            {endTimeIsValid && (
                              <span className="text-red-500 text-xs italic">
                                Please select a valid end time.
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="form-field-client">
                        <label htmlFor="description" className="form-label">
                          Upload Document
                        </label>
                        <input
                          type="file"
                          name="Upload Document"
                          className={
                            documentIsValid
                              ? "input-validation-error form-select"
                              : "form-input"
                          }
                          onChange={handleUploadDocChange}
                          ref={documentRef}
                        />
                        {documentIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Invalid file format
                          </span>
                        )}
                      </div>
                      <div className="form-field-client">
                        <label htmlFor="description" className="form-label">
                          Remarks
                        </label>
                        <textarea
                          id="Remark"
                          required
                          name="Remark"
                          className={
                            noteIsValid
                              ? "input-validation-error form-textarea"
                              : "form-textarea"
                          }
                          rows="3"
                          value={note}
                          onChange={(e) => setNote(e.target.value)}
                          ref={noteRef}
                        ></textarea>
                        {noteIsValid && (
                          <span className="text-red-500 text-xs italic">
                            Remark Cannot be empty
                          </span>
                        )}
                      </div>
                      <button type="submit" disabled={isSubmitLoading} className="submit-client" style={isSubmitLoading ? { cursor: "not-allowed", opacity: 0.6 } : {}}>
                        {isSubmitLoading ? (
                          <div
                            style={{
                              width: "130px",
                              height: "18px",
                              backgroundColor: "#ffffff",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                              display: "inline-block",
                            }}
                          />
                        ) : (
                          "Create Request"
                        )}
                      </button>
                    </form>
                  </div>
                </div>
              </Modal>
              <div className="search-userandmail">
                <a onClick={exportToExcel}>
                  <span className="icon-invoice">
                    <img src={DownloadImage} alt="Export" />
                  </span>
                  Export Data
                </a>
              </div>
              <TimeOffDetailsModal
                isOpen={isDetailsModalOpen}
                onClose={handleCloseDetailsModal}
                isSubmitLoading={isSubmitLoading}
                timeOffData={editRowData}
                user={user}
                onEdit={handleEdit}
                onDownloadDocument={downloadTimeOffDoc}
                onApprove={handleApprove}
                onReject={handleReject}
                onCancel={handleCancel}
                onDelete={handleDelete}
                approveModalOpen={isApproveModalOpen}
                rejectModalOpen={isRejectModalOpen}
                cancelModalOpen={isCancelModalOpen}
                deleteModalOpen={isDeleteModalOpen}
                onCancelApprove={handleCancelApprove}
                onCancelReject={handleCancelReject}
                onCancelCancel={handleCancelCancel}
                onCancelDelete={handleCancelDelete}
                onConfirmApprove={handleConfirmApprove}
                onConfirmReject={handleConfirmReject}
                onConfirmCancel={handleConfirmCancel}
                onConfirmDelete={handleConfirmDelete}
                SUPER_ADMIN={SUPER_ADMIN}
                ADMIN={ADMIN}
                USER={USER}
                TEAM_MANAGER={TEAM_MANAGER}
              />
            </div>

            {/* edit section */}
            <Modal
              className="client-modal sprint-modal time-off-close"
              isOpen={isEditModalOpen}
              onRequestClose={!isSubmitLoading ? handleCloseEditModal : undefined}
              contentLabel="Confirm Delete"
              style={{
                content: {
                  height: "41%",
                  width: "30%",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  parent: document.querySelector(".admin-outer.time.tracker"),
                },
              }}
            >
              <div className="modal timeoff-modal">
                <div className="modal-close-invite outter-modal-main">
                  <a className="" onClick={handleCloseEditModal} disabled={isSubmitLoading}>
                    <img src={crssrImage} alt="Edit Icon" />{" "}
                  </a>
                </div>
                <div className="modal-client-head">
                  <h2 className="">Update Time Off Request</h2>
                </div>
                <div className="form-field-client-outer">
                  <form onSubmit={handleTimeOffEditSubmit}>
                    {(user.userType === 1 || user.userType === 2) &&
                      (<div className="form-field-client">
                        <label htmlFor="client" className="form-label">
                          User
                        </label>
                        <div ref={userSelectDropdownRef} className={`cursor ${userDropdownOpen ? 'open' : ''}`} >
                          <span
                            id="user-select"
                            onClick={handleToggleUserDropdown}
                            className={`custom-dropdown-user-new custom-dropdown-user ${userEditIsValid ? 'input-validation-error' : ''}`}
                            ref={userRef}
                          >
                            {userIdEdit ? (
                              activeUser?.find((user) => user._id === userIdEdit)?.first_name ? (
                                <>
                                  {activeUser?.find((user) => user._id === userIdEdit)?.first_name}{' '}
                                  {activeUser?.find((user) => user._id === userIdEdit)?.middle_name &&
                                    activeUser?.find((user) => user._id === userIdEdit)?.middle_name !== 'null'
                                    ? activeUser?.find((user) => user._id === userIdEdit)?.middle_name + ' '
                                    : ''}
                                  {activeUser?.find((user) => user._id === userIdEdit)?.last_name}{' '}
                                </>
                              ) : (
                                <>
                                  {activeUser.find((user) => user._id === userIdEdit)?.company_first_name
                                    ? `${activeUser.find((user) => user._id === userIdEdit)?.company_first_name} ${activeUser.find((user) => user._id === userIdEdit)?.company_last_name
                                      ? activeUser.find((user) => user._id === userIdEdit)?.company_last_name
                                      : ''
                                    }`
                                    : `${activeUser.find((user) => user._id === userIdEdit)?.company_name || ''}(Company)`}
                                </>
                              )
                            ) : (
                              'Select User'
                            )}
                          </span>
                          {userDropdownOpen && (
                            <div className="custom-dropdown-new">
                              <input
                                type="text"
                                className="search-bar"
                                placeholder="Search..."
                                value={userSearchTerm}
                                onChange={handleUserSearchInputChange}
                              />
                              <ul className="client-list">
                                {filteredUsers.length > 0 &&
                                  filteredUsers
                                    .slice()
                                    .sort((a, b) => {
                                      const nameA = a.first_name
                                        ? `${a.first_name} ${a.middle_name || ''} ${a.last_name}`
                                        : `${a.company_first_name ? a.company_first_name + (a.company_last_name && a.company_last_name) : a.company_name}`;
                                      const nameB = b.first_name
                                        ? `${b.first_name} ${b.middle_name || ''} ${b.last_name}`
                                        : `${b.company_first_name ? b.company_first_name + (b.company_last_name && b.company_last_name) : b.company_name}`;
                                      return nameA.localeCompare(nameB);
                                    })
                                    .map((item) => (
                                      <li key={item._id} className={userIdEdit === item._id ? 'selected-item' : ''} onClick={() => handleSelectUserEdit(item._id)}>
                                        {item.first_name ? (
                                          <>
                                            {item.first_name}{' '}
                                            {item.middle_name && item.middle_name !== 'null' ? item.middle_name + ' ' : ''}
                                            {item.last_name}{' '}
                                          </>
                                        ) : (
                                          <>
                                            {item.company_first_name
                                              ? `${item.company_first_name} ${item.company_last_name ? item.company_last_name : ''}`
                                              : `${item.company_name || ''}(Company)`}
                                          </>
                                        )}
                                      </li>
                                    ))
                                }
                              </ul>
                            </div>
                          )}
                        </div>

                        {userEditIsValid && (
                          <span className="text-red-500 text-xs italic">
                            User needs to be selected
                          </span>
                        )}
                      </div>)}
                    <div className="form-field-client">
                      <label htmlFor="client" className="form-label">
                        Type of Leave
                      </label>
                      <div
                        ref={leaveTypeSelectDropdownRef}
                        className={`cursor ${leaveTypeDropdownOpen ? 'open' : ''}`}
                      >
                        <span
                          id="user-select"
                          onClick={() => setLeaveTypeDropdownOpen(!leaveTypeDropdownOpen)}
                          className={`custom-dropdown-user-new custom-dropdown-select ${leaveTypeIsValid ? 'input-validation-error' : ''}`}
                          ref={leaveTypeEditRef}
                        >
                          {typeOfLeaveEdit ? leaveType.find((leave) => leave._id === typeOfLeaveEdit)?.leave_type : 'Select'}
                        </span>
                        {leaveTypeDropdownOpen && (
                          <div className="custom-dropdown-new">
                            <ul className="leave-type-list">
                              {leaveType &&
                                leaveType
                                  .slice()
                                  .sort((a, b) => a.leave_type?.toLowerCase().localeCompare(b.leave_type?.toLowerCase()))
                                  .map((leave) => (
                                    <li
                                      key={leave._id}
                                      className={typeOfLeaveEdit === leave._id ? 'selected-item' : ''}
                                      onClick={() => {
                                        setTypeOfLeaveEdit(leave._id);
                                        setLeaveTypeDropdownOpen(false);
                                      }}
                                    >
                                      {leave.leave_type}
                                    </li>
                                  ))}
                            </ul>
                          </div>
                        )}
                      </div>
                      {leaveTypeEditIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Leave Type field Cannot be empty
                        </span>
                      )}
                    </div>
                    <div className="form-field-client" >
                      <label htmlFor="projectName" className="form-label">
                        Time Off Dates
                      </label>
                      <div className="date-picker-outer date-picker-outer-all">
                        <div className="custom-picker-icon custom-picker-icon-all">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            className="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>
                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <div ref={dateRangeRef}>
                            <DateRangePicker
                              showOneCalendar
                              format="dd/MM/yyyy"
                              placeholder="From - to"
                              placement="topEnd"
                              ranges={ranges}
                              className="project-calender time-off-cal"
                              value={dateRangeEdit}
                              onChange={handleSelectEdit}
                              isoWeek={appSettings.weekStartDay === 'Monday'}
                            />
                          </div>
                        </div>
                      </div>

                      {dateRangeEditIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Select the range of dates you want time off
                        </span>
                      )}
                    </div>
                    {dateRangeTypeEdit === "single" && (
                      <div className="form-field-client radio-sec">
                        <div className="form-field-client">
                          <label htmlFor="client" className="form-label">
                            Start Time
                          </label>

                          <div
                            className={`custom-dropdown-user-new-outer custom-dropdown-select ${startTimeDropdownOpen ? 'open' : ''
                              }`}
                            ref={startTimeDropdownRef}
                          >
                            <div
                              className="selected-option custom-dropdown-user-new"
                              onClick={handleToggleStartTimeDropdown}
                              style={{ cursor: 'pointer' }}
                              ref={startTimeRef}
                            >
                              {startTimeEdit ? timeList.find((time) => time.time_value === startTimeEdit)?.time : 'Select'}
                            </div>
                            {startTimeDropdownOpen && (
                              <div className="custom-dropdown-new">
                                <ul className="time-list">
                                  {timeList.map((time) => (
                                    <li
                                      key={time.time_value}
                                      className={startTimeEdit === time.time_value ? 'selected-item' : ''}
                                      onClick={() => {
                                        setStartTimeEdit(time.time_value);
                                        setStartTimeDropdownOpen(false);
                                      }}
                                    >
                                      {time.time}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          {startTimeEditIsValid && (
                            <span className="text-red-500 text-xs italic">
                              Please select a valid start time.
                            </span>
                          )}
                        </div>
                        <div className="form-field-client">
                          <label htmlFor="client" className="form-label">
                            End Time
                          </label>

                          <div className={`custom-dropdown-user-new-outer custom-dropdown-select ${endTimeDropdownOpen ? 'open' : ''}`} ref={endTimeDropdownRef}>
                            <div
                              className="selected-option custom-dropdown-user-new"
                              onClick={handleToggleEndTimeDropdown}
                              style={{ cursor: 'pointer' }}
                              ref={endTimeRef}
                            >
                              {endTimeEdit ? timeList.find((time) => time.time_value === endTimeEdit)?.time : 'Select'}
                            </div>
                            {endTimeDropdownOpen && (
                              <div className="custom-dropdown-new">
                                <ul className="time-list">
                                  {timeList.map((time) => (
                                    <li
                                      key={time.time_value}
                                      className={endTimeEdit === time.time_value ? 'selected-item' : ''}
                                      onClick={() => {
                                        setEndTimeEdit(time.time_value);
                                        setEndTimeDropdownOpen(false);
                                      }}
                                    >
                                      {time.time}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                          {endTimeEditIsValid && (
                            <span className="text-red-500 text-xs italic">
                              Please select a valid end time.
                            </span>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="form-field-client">
                      <label htmlFor="description" className="form-label">
                        Upload Document
                      </label>
                      <input
                        type="file"
                        name="Upload Document"
                        className={
                          documentEditIsValid
                            ? "input-validation-error form-select"
                            : "form-input"
                        }
                        onChange={handleUploadDocEditChange}
                        ref={documentRef}
                      />
                      {uploadDocumentEditName &&
                        <div
                          onClick={() => downloadTimeOffDoc(uploadDocumentEditName)}
                          style={{ cursor: 'pointer' }}
                        >
                          {uploadDocumentEditName.length > 30 ? (
                            <span
                              className="shortened-name"
                              title={uploadDocumentEditName}
                            >
                              {uploadDocumentEditName.slice(0, 30)}...
                            </span>
                          ) : (
                            uploadDocumentEditName
                          )}
                        </div>
                      }
                      {documentEditIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Invalid file format
                        </span>
                      )}
                    </div>
                    <div className="form-field-client">
                      <label htmlFor="description" className="form-label">
                        Remarks
                      </label>
                      <textarea
                        id="Remark"
                        required
                        name="Remark"
                        className={
                          noteEditIsValid
                            ? "input-validation-error form-textarea"
                            : "form-textarea"
                        }
                        rows="3"
                        value={noteEdit}
                        onChange={(e) => setNoteEdit(e.target.value)}
                        ref={noteRef}
                      ></textarea>
                      {noteEditIsValid && (
                        <span className="text-red-500 text-xs italic">
                          Remark Cannot be empty
                        </span>
                      )}
                    </div>
                    <button type="submit" disabled={isSubmitLoading} className="submit-client" style={isSubmitLoading ? { cursor: "not-allowed", opacity: 0.6 } : {}}>
                      {isSubmitLoading ? (
                        <div
                          style={{
                            width: "130px",
                            height: "18px",
                            backgroundColor: "#ffffff",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                            display: "inline-block",
                          }}
                        />
                      ) : (
                        "Update Request"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </Modal>
            {/* edit section */}
            <div className="search-sec">
              <div className="search-container">
                <input
                  type="text"
                  onChange={handleFilterChange}
                  value={filter}
                  className="search-input"
                  placeholder="Search"
                />
              </div>
            </div>
          </div>
          <div className="overview-top-right" ref={targetRef} >
            <div className="range-timeoff mobile-hide">
              <div className="range-timeoff-inner" >
                <div className="range-title">Date Range</div>
                <div className="date-picker-outer date-picker-outer-all" ref={calendarRef}>
                  <div className="custom-picker-icon custom-picker-icon-all">
                    <svg
                      width="1em"
                      height="1em"
                      viewBox="0 0 14 14"
                      fill="currentColor"
                      aria-hidden="true"
                      focusable="false"
                      className="rs-picker-toggle-caret rs-icon"
                      aria-label="calendar"
                      data-category="legacy"
                    >
                      <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                    </svg>
                  </div>
                  <div className="custoom-icon-calender custoom-icon-calender-all">
                    <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">
                      <input
                        type="text"
                        value={
                          selectedRange ?
                            `${new Date(selectedRange[0]).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })} to ${new Date(selectedRange[1]).toLocaleDateString("en-GB", {
                              day: "2-digit",
                              month: "2-digit",
                              year: "numeric",
                            })}`
                            : ''
                        }
                        id="date-range"
                        name="date-range"
                        placeholder="All Time"
                        onClick={toggleCalendar}
                        autoComplete="off"
                        readOnly
                      />
                    </div>
                    <div className="date-range-new left-align">
                      {showCalendar && <Calendar onCancel={cancelCalendar} onChange={onDateChange} initialRange={{ startDate: selectedRange ? selectedRange[0] : null, endDate: selectedRange ? selectedRange[1] : null }} />}
                    </div>
                  </div>
                </div>
              </div>

              {(user.userType === SUPER_ADMIN || user.userType === ADMIN || user.userType === TEAM_MANAGER || user.userType === PROJECT_MANAGER) && (
                <div className="range-timeoff-user">
                  <label>User</label>
                  <div className="custom-dropdown1 new-active-inactive" ref={userDropdownRef}>
                    <div className="drop-down-inner">
                      {isLoadingUser || isLoadingActiveUser ? (
                        <div className="selected-options1" style={{ cursor: "default", pointerEvents: "none" }}>
                          <div
                            style={{
                              width: "120px",
                              height: "20px",
                              backgroundColor: "#e5e7eb",
                              borderRadius: "4px",
                              animation: "pulse 1.5s ease-in-out infinite",
                            }}
                          />
                        </div>
                      ) : (
                        <div className="selected-options1" onClick={toggleUserDropdown}>
                          {selectedUsers.length === 0 ? (
                            <div className="placeholder">Select</div>
                          ) : (
                            <>
                              <div className="selected-option1" key={selectedUsers[0]}>
                                {/* {selectedUsers.length === userIds.length */}
                                {selectedUsers.length === userIds.filter((user) => userStatusFilter === "All" ? true : userStatusFilter === "Active" ? user.is_active === true : user.is_active === false).length ? (
                                  'All'
                                ) : (
                                  <>
                                    <TruncateFilterFieldView textContent={
                                      userIds.find((item) => item._id === selectedUsers[0])?.first_name
                                        ? `${userIds.find((item) => item._id === selectedUsers[0]).first_name} ${userIds.find((item) => item._id === selectedUsers[0]).middle_name
                                          ? userIds.find((item) => item._id === selectedUsers[0]).middle_name
                                          : ''
                                        } ${userIds.find((item) => item._id === selectedUsers[0]).last_name
                                          ? userIds.find((item) => item._id === selectedUsers[0]).last_name
                                          : ''
                                        }`
                                        : (
                                          userIds.find((item) => item._id === selectedUsers[0])?.company_first_name
                                            ? `${userIds.find((item) => item._id === selectedUsers[0])?.company_first_name} ${userIds.find((item) => item._id === selectedUsers[0])?.company_last_name
                                              ? userIds.find((item) => item._id === selectedUsers[0])?.company_last_name
                                              : ''
                                            }`
                                            : `${userIds.find((item) => item._id === selectedUsers[0]).company_name} (Company)`
                                        )
                                    } />
                                    {selectedUsers.length > 1 && selectedUsers.length !== userIds.length && (
                                      <div className="selected-option-count">
                                        {selectedUsers.length - 1}+
                                      </div>
                                    )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                        </div>
                      )}
                      {!isLoadingUser && !isLoadingActiveUser && isUserDropdownOpen && (
                        <div className="dropdown-list1">
                          {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                            <>
                              <div className="user-status-dropdown">
                                <div className="user-status-dropdown-label" htmlFor="userStatusFilter">Filter by Status</div>
                                <div className="custom-dropdown-user" ref={userStatusDropdownRef}>
                                  <div className={`showing-name ${isUserStatusDropdownOpen ? 'open' : 'close'}`} onClick={toggleUserStatusDropdown}>
                                    {userStatusFilter ? userStatusFilter : "Active"}
                                  </div>
                                </div>
                              </div>
                              {isUserStatusDropdownOpen && (
                                <ul className="status-list">
                                  <li
                                    onClick={() => handleUserStatusChange("All")}
                                    className={userStatusFilter === "All" ? "selected-item" : ""}
                                  >
                                    All
                                  </li>
                                  <li
                                    onClick={() => handleUserStatusChange("Active")}
                                    className={userStatusFilter === "Active" ? "selected-item" : ""}
                                  >
                                    Active
                                  </li>
                                  <li
                                    onClick={() => handleUserStatusChange("Inactive")}
                                    className={userStatusFilter === "Inactive" ? "selected-item" : ""}
                                  >
                                    Inactive
                                  </li>
                                </ul>
                              )}
                            </>
                          )}

                          <div className="top-search-tracker-for">
                            <input
                              type="text"
                              placeholder="Search teams"
                              value={userDropdownSearchTerm}
                              onChange={handleUserDropdownSearchChange}
                              className="search-bar"
                            />
                          </div>
                          <div className="tracker-who-list">
                            {filteredDropdownUsers.filter(user => userStatusFilter === "All" ? true : userStatusFilter === "Active" ? user.is_active === true : user.is_active === false).length > 0 && (
                              <>
                                {userDropdownSearchTerm === "" && (
                                  <label className="checkbox-label1" key="selectAll">
                                    <input
                                      type="checkbox"
                                      checked={selectAllUser}
                                      onChange={handleSelectAllUserChange}
                                    />
                                    All
                                  </label>
                                )}
                                {filteredDropdownUsers
                                  .filter((user) =>
                                    userStatusFilter === "All" ? true : userStatusFilter === "Active" ? user.is_active === true : user.is_active === false
                                  )
                                  .map((user) => (
                                    <label className="checkbox-label1" key={user._id}>
                                      <input
                                        type="checkbox"
                                        checked={selectedUsers.includes(user._id)}
                                        onChange={() => handleCheckboxUserChange(user._id)}
                                      />
                                      {user.first_name ? `${user.first_name} ${user.middle_name ? user.middle_name : ''} ${user.last_name}` : (user.company_first_name ? `${user.company_first_name} ${user.company_last_name ? user.company_last_name : ''}` : `${user.company_name} (Company)`)}
                                    </label>
                                  ))}
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="range-timeoff-user">
                <label>Status</label>
                <div className="custom-dropdown1" ref={statusDropdownRef}>
                  <div className="drop-down-inner">
                    {!hasInitializedSelectedStatusRef.current ? (
                      <div className="selected-options1" style={{ cursor: "default", pointerEvents: "none" }}>
                        <div
                          style={{
                            width: "80px",
                            height: "20px",
                            backgroundColor: "#e5e7eb",
                            borderRadius: "4px",
                            animation: "pulse 1.5s ease-in-out infinite",
                          }}
                        />
                      </div>
                    ) : (
                      <div className="selected-options1" onClick={toggleStatusDropdown}>
                        {selectedStatus.length === 0 ? (
                          <div className="placeholder">Select</div>
                        ) : (
                          <div className="selected-option1" key={selectedStatus[0]}>
                            {selectedStatus.length === 4
                              ? 'All'
                              : (
                                <>
                                  <TruncateFilterFieldView textContent={selectedStatus[0]} />
                                  {selectedStatus.length > 1 && selectedStatus.length !== 4 && (
                                    <div className="selected-option-count">
                                      {selectedStatus.length - 1}+
                                    </div>
                                  )}
                                </>
                              )}
                          </div>
                        )}
                      </div>
                    )}
                    {isStatusDropdownOpen && (
                      <div className="dropdown-list1">
                        <>
                          <label className="checkbox-label1" key="selectAll">
                            <input
                              type="checkbox"
                              checked={selectAllStatus}
                              onChange={handleSelectAllStatusChange}
                            />
                            All
                          </label>

                          <label className="checkbox-label1" key="Pending">
                            <input
                              type="checkbox"
                              checked={selectedStatus.includes("Pending")}
                              onChange={() => handleCheckboxStatusChange("Pending")}
                            />
                            Pending
                          </label>

                          <label className="checkbox-label1" key="Approved">
                            <input
                              type="checkbox"
                              checked={selectedStatus.includes("Approved")}
                              onChange={() => handleCheckboxStatusChange("Approved")}
                            />
                            Approved
                          </label>

                          <label className="checkbox-label1" key="Rejected">
                            <input
                              type="checkbox"
                              checked={selectedStatus.includes("Rejected")}
                              onChange={() => handleCheckboxStatusChange("Rejected")}
                            />
                            Rejected
                          </label>

                          <label className="checkbox-label1" key="Cancelled">
                            <input
                              type="checkbox"
                              checked={selectedStatus.includes("Cancelled")}
                              onChange={() => handleCheckboxStatusChange("Cancelled")}
                            />
                            Cancelled
                          </label>
                        </>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* )} */}
            </div>
            <div className="filter-outer-expense">
              <div className="filter-invoice-right apply-fliter-right desktop-hide">
                <button onClick={toggleFilterModal}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="13"
                    height="17"
                    viewBox="0 0 13 17"
                    fill="none"
                  >
                    <path
                      d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z"
                      fill="#6479F8"
                    />
                    <path
                      d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z"
                      fill="#6479F8"
                    />
                    <path
                      d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z"
                      fill="#6479F8"
                    />
                  </svg>
                  All Filters
                </button>
              </div>
              <Modal
                isOpen={showFilterModal}
                onRequestClose={toggleFilterModal}
                contentLabel="Filter Modal"
                className="new-filter-modal"
                style={{
                  content: {
                    height: "50%",
                    width: "50%",
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    backgroundColor: "#fff",
                    padding: "20px",
                    // overflow: "auto",
                  },
                  overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  },
                }}
              >
                <div className="new-nodal-invoice-outer-sec">
                  <div className="new-modal-top-sec">
                    <div className="new-modal-heading">
                      All filters
                    </div>
                    <a className="close-image-clr1" onClick={checkAndShowConfirmationModal}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1 13L13 1" stroke="black" />
                        <path d="M1 0.999999L13 13" stroke="black" />
                      </svg>{" "}
                    </a>
                  </div>
                  <div className="invoice-filter-inner-section">
                    <div className="filter-inner users">
                      <label htmlFor="fname">Date Range</label>
                      <div className="date-picker-outer date-picker-outer-all" ref={modalCalendarRef}>
                        <div className="custom-picker-icon custom-picker-icon-all">
                          <svg
                            width="1em"
                            height="1em"
                            viewBox="0 0 14 14"
                            fill="currentColor"
                            aria-hidden="true"
                            focusable="false"
                            className="rs-picker-toggle-caret rs-icon"
                            aria-label="calendar"
                            data-category="legacy"
                          >
                            <path d="M1 4v8.5a.5.5 0 00.5.5H8c0-.128.049-.256.146-.354.555-.555.854-1.6.854-3.146a.5.5 0 01.621-.485l.119.03A2.623 2.623 0 0012.999 6.5V4h-12zm3-2h6V0h1v2h1.5A1.5 1.5 0 0114 3.5v3a3.623 3.623 0 01-4.015 3.603c-.064 1.245-.335 2.212-.831 2.898H12.5a.5.5 0 00.5-.5v-2a.5.5 0 011 0v2a1.5 1.5 0 01-1.5 1.5h-11a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5H3v-2h1v2zm5 4V5h1v1h2v1h-2v1H9V7H7v2h1v1H7v2H6v-2H4v2H3v-2H1V9h2V7H1V6h2V5h1v1h2V5h1v1h2zM6 9V7H4v2h2z"></path>
                          </svg>
                        </div>
                        <div className="custoom-icon-calender custoom-icon-calender-all">
                          <div className="custoom-icon-calender custoom-icon-calender-all custom-date-range">
                            <input
                              type="text"
                              value={
                                selectedRange ?
                                  `${new Date(selectedRange[0]).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })} to ${new Date(selectedRange[1]).toLocaleDateString("en-GB", {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                  })}`
                                  : null
                              }
                              id="date-range"
                              name="date-range"
                              placeholder="All Time"
                              onClick={toggleModalCalendar}
                              autoComplete="off"
                            />
                          </div>
                          <div className="date-range-new left-align">
                            {showModalCalendar && <Calendar onCancel={cancelModalCalendar} onChange={onDateChange} initialRange={{ startDate: selectedRange ? selectedRange[0] : null, endDate: selectedRange ? selectedRange[1] : null }} />}
                          </div>
                        </div>
                      </div>
                    </div>
                    {(user.userType === SUPER_ADMIN || user.userType === ADMIN || user.userType === TEAM_MANAGER || user.userType === PROJECT_MANAGER) &&
                      (<div className="filter-inner invoice-project">
                        <label htmlFor="invoiceproject">User</label>
                        <div className="custom-dropdown1" ref={userModalDropdownRef}>
                          <div className="drop-down-inner">
                            <div className="selected-options1" onClick={toggleUserModalDropdown}>
                              {selectedUsers.length === 0 ? (
                                <div className="placeholder">Select</div>
                              ) : (
                                <>
                                  <div className="selected-option1" key={selectedUsers[0]}>
                                    {selectedUsers.length === userIds.filter((user) => userStatusFilter === "All" ? true : userStatusFilter === "Active" ? user.is_active === true : user.is_active === false).length ? (
                                      'All')
                                      : (<>
                                        <TruncateFilterFieldView textContent={
                                          userIds.find((item) => item._id === selectedUsers[0])?.first_name
                                            ? `${userIds.find((item) => item._id === selectedUsers[0]).first_name} ${userIds.find((item) => item._id === selectedUsers[0]).middle_name
                                              ? userIds.find((item) => item._id === selectedUsers[0]).middle_name
                                              : ''
                                            } ${userIds.find((item) => item._id === selectedUsers[0]).last_name
                                              ? userIds.find((item) => item._id === selectedUsers[0]).last_name
                                              : ''
                                            }`
                                            : (
                                              userIds.find((item) => item._id === selectedUsers[0]).company_first_name
                                                ? `${userIds.find((item) => item._id === selectedUsers[0]).company_first_name} ${userIds.find((item) => item._id === selectedUsers[0]).company_last_name
                                                  ? userIds.find((item) => item._id === selectedUsers[0]).company_last_name
                                                  : ''
                                                }`
                                                : `${userIds.find((item) => item._id === selectedUsers[0]).company_name} (Company)`
                                            )
                                        } />
                                        {selectedUsers.length > 1 && selectedUsers.length !== userIds.length && (
                                          <div className="selected-option-count">
                                            {selectedUsers.length - 1}+
                                          </div>
                                        )}
                                      </>)}
                                  </div>
                                </>
                              )}
                            </div>
                            {isUserModalDropdownOpen && (
                              <div className="dropdown-list1">
                                {(user.userType === userTypeConsts.SUPER_ADMIN || user.userType === userTypeConsts.ADMIN) && (
                                  <>
                                    <div className="user-status-dropdown">
                                      <div htmlFor="userStatusFilter">Filter by Status</div>
                                      <div className="custom-dropdown-user" ref={userStatusModalDropdownRef}>
                                        <div className="showing-name" onClick={toggleUserStatusModalDropdown}>
                                          {userStatusFilter ? userStatusFilter : "Active"}
                                        </div>
                                      </div>
                                    </div>
                                    {isUserStatusModalDropdownOpen && (
                                      <ul className="status-list">
                                        <li
                                          onClick={() => handleUserStatusChange("All")}
                                          className={userStatusFilter === "All" ? "selected-item" : ""}
                                        >
                                          All
                                        </li>
                                        <li
                                          onClick={() => handleUserStatusChange("Active")}
                                          className={userStatusFilter === "Active" ? "selected-item" : ""}
                                        >
                                          Active
                                        </li>
                                        <li
                                          onClick={() => handleUserStatusChange("Inactive")}
                                          className={userStatusFilter === "Inactive" ? "selected-item" : ""}
                                        >
                                          Inactive
                                        </li>
                                      </ul>
                                    )}
                                  </>
                                )}
                                <input
                                  type="text"
                                  placeholder="Search teams"
                                  value={userDropdownSearchTerm}
                                  onChange={handleUserDropdownSearchChange}
                                  className="search-bar"
                                />
                                {filteredDropdownUsers.filter(user => userStatusFilter === "All" ? true : userStatusFilter === "Active" ? user.is_active === true : user.is_active === false).length > 0 && (
                                  <>
                                    {userDropdownSearchTerm === "" && (
                                      <label className="checkbox-label1" key="selectAll">
                                        <input
                                          type="checkbox"
                                          checked={selectAllUser}
                                          onChange={handleSelectAllUserChange}
                                        />
                                        All
                                      </label>
                                    )}
                                    {filteredDropdownUsers
                                      .filter((user) =>
                                        userStatusFilter === "All" ? true : userStatusFilter === "Active" ? user.is_active === true : user.is_active === false
                                      )
                                      .map((user) => (
                                        <label className="checkbox-label1" key={user._id}>
                                          <input
                                            type="checkbox"
                                            checked={selectedUsers.includes(user._id)}
                                            onChange={() => handleCheckboxUserChange(user._id)}
                                          />
                                          {user.first_name ? `${user.first_name} ${user.middle_name ? user.middle_name : ''} ${user.last_name}` : (user.company_first_name ? `${user.company_first_name} ${user.company_last_name ? user.company_last_name : ''}` : `${user.company_name} (Company)`)}
                                        </label>
                                      ))}
                                  </>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>)}
                    <div className="filter-inner due-date">
                      <label htmlFor="dueDate" className="calendar-icon">
                        Status
                      </label>
                      <div className="custom-dropdown1" ref={statusModalDropdownRef}>
                        <div className="drop-down-inner">
                          <div className="selected-options1" onClick={toggleStatusModalDropdown}>
                            {selectedStatus.length === 0 ? (
                              <div className="placeholder">Select</div>
                            ) : (
                              <>
                                <div className="selected-option1" key={selectedStatus[0]}>
                                  {selectedStatus.length === 4
                                    ? 'All'
                                    : (<>

                                      <TruncateFilterFieldView textContent={selectedStatus[0]} />
                                      {selectedStatus.length > 1 && selectedStatus.length !== 4 && (
                                        <div className="selected-option-count">
                                          {selectedStatus.length - 1}+
                                        </div>
                                      )}
                                    </>)}
                                </div>
                              </>
                            )}
                          </div>
                          {isStatusModalDropdownOpen && (
                            <div className="dropdown-list1">
                              <>
                                <label className="checkbox-label1" key="selectAll">
                                  <input
                                    type="checkbox"
                                    checked={selectAllStatus}
                                    onChange={handleSelectAllStatusChange}
                                  />
                                  All
                                </label>

                                <label className="checkbox-label1" key="Pending">
                                  <input
                                    type="checkbox"
                                    checked={selectedStatus.includes("Pending")}
                                    onChange={() => handleCheckboxStatusChange("Pending")}
                                  />
                                  Pending
                                </label>

                                <label className="checkbox-label1" key="Approved">
                                  <input
                                    type="checkbox"
                                    checked={selectedStatus.includes("Approved")}
                                    onChange={() => handleCheckboxStatusChange("Approved")}
                                  />
                                  Approved
                                </label>

                                <label className="checkbox-label1" key="Rejected">
                                  <input
                                    type="checkbox"
                                    checked={selectedStatus.includes("Rejected")}
                                    onChange={() => handleCheckboxStatusChange("Rejected")}
                                  />
                                  Rejected
                                </label>

                                <label className="checkbox-label1" key="Cancelled">
                                  <input
                                    type="checkbox"
                                    checked={selectedStatus.includes("Cancelled")}
                                    onChange={() => handleCheckboxStatusChange("Cancelled")}
                                  />
                                  Cancelled
                                </label>
                              </>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="filter-buttons">
                    <button className="clear-all" onClick={clearFilters}>Clear All</button>
                    <button className="apply-filter" onClick={applyFilters}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="13" height="17" viewBox="0 0 13 17" fill="none">
                        <path d="M11.7363 8.81108C11.4276 9.81451 10.4925 10.5444 9.38889 10.5444C8.28471 10.5444 7.35016 9.8141 7.04147 8.81108L0.722221 8.81108C0.323349 8.81108 -1.07845e-06 8.48773 -1.06101e-06 8.08886C-1.04357e-06 7.68998 0.323349 7.36663 0.722221 7.36663L7.04144 7.36663C7.35022 6.3632 8.28529 5.6333 9.38889 5.6333C10.4931 5.6333 11.4276 6.36362 11.7363 7.36663L12.2778 7.36663C12.6767 7.36663 13 7.68998 13 8.08886C13 8.48773 12.6766 8.81108 12.2778 8.81108L11.7363 8.81108ZM9.38889 7.07775C8.83162 7.07775 8.37778 7.53123 8.37778 8.08886C8.37778 8.64613 8.83127 9.09997 9.38889 9.09997C9.94616 9.09997 10.4 8.64648 10.4 8.08886C10.4 7.53158 9.94651 7.07775 9.38889 7.07775Z" fill="white" />
                        <path d="M5.38078 3.17778C5.072 4.18121 4.13693 4.91111 3.03333 4.91111C1.92882 4.91111 0.994035 4.18035 0.68563 3.17687C0.303759 3.15781 -1.07791e-06 2.84216 -1.06101e-06 2.45556C-1.04411e-06 2.06896 0.303748 1.75331 0.685606 1.73425C0.994098 0.730343 1.9294 -4.83911e-07 3.03333 -4.35657e-07C4.13752 -3.87392e-07 5.07206 0.730315 5.38076 1.73333L12.2778 1.73333C12.6767 1.73333 13 2.05668 13 2.45556C13 2.85443 12.6766 3.17778 12.2778 3.17778L5.38078 3.17778ZM3.03333 1.44444C2.47606 1.44444 2.02222 1.89793 2.02222 2.45556C2.02222 3.01283 2.47571 3.46667 3.03333 3.46667C3.5906 3.46667 4.04444 3.01318 4.04444 2.45556C4.04444 1.89828 3.59096 1.44444 3.03333 1.44444Z" fill="white" />
                        <path d="M7.403 14.4444C7.09422 15.4478 6.15916 16.1777 5.05556 16.1777C3.95137 16.1777 3.01682 15.4474 2.70813 14.4444L0.722221 14.4444C0.323349 14.4444 -1.07845e-06 14.121 -1.06101e-06 13.7222C-1.04357e-06 13.3233 0.323349 12.9999 0.722221 12.9999L2.70811 12.9999C3.01689 11.9965 3.95195 11.2666 5.05556 11.2666C6.15974 11.2666 7.09429 11.9969 7.40298 12.9999L12.2778 12.9999C12.6767 12.9999 13 13.3233 13 13.7222C13 14.121 12.6766 14.4444 12.2778 14.4444L7.403 14.4444ZM5.05556 12.711C4.49828 12.711 4.04444 13.1645 4.04444 13.7222C4.04444 14.2794 4.49793 14.7333 5.05556 14.7333C5.61283 14.7333 6.06667 14.2798 6.06667 13.7222C6.06667 13.1649 5.61318 12.711 5.05556 12.711Z" fill="white" />
                      </svg>
                      Apply Filters
                    </button>
                  </div>
                </div>
              </Modal>

              <Modal
                isOpen={showConfirmationModal}
                onRequestClose={() => setShowConfirmationModal(false)}
                contentLabel="Confirmation Modal"
                ariaHideApp={false}
                className="confirmation-modal"
                overlayClassName="confirmation-modal-overlay"
              >
                <div className="modal-content">
                  <h2>Are you sure?</h2>
                  <p>Are you sure you want to clear the filters?</p>
                  <div className="modal-footer">
                    <button className="cancel-btn" onClick={() => setShowConfirmationModal(false)}>
                      Cancel
                    </button>
                    <button className="confirm-btn" onClick={handleApplyConfirm}>
                      Yes, Clear
                    </button>
                  </div>
                </div>
              </Modal>
            </div>
            <div className="showing-count showing-count-timeoff">
              <div className="filter-inner showing-result show-result-team-fill">
                <label>Showing</label>
                <div ref={showingDropdownRef} className="select-modal-mainM custom-dropdown-user-new-outer">
                  <div className="selected-option custom-dropdown-user-new" onClick={() => setShowingDropdownOpen(!showingDropdownOpen)}>
                    {total < 10 ? total.toString() : perPage.toString()}
                  </div>
                  {showingDropdownOpen && (
                    <div className="custom-dropdown-new">
                      <ul className="showing-options-list">
                        {total >= 10 && <li className={perPage === 10 ? 'selected-item' : ''} onClick={() => { setPerPage(10); setCurrentPage(1); setShowingDropdownOpen(false); }}>10</li>}
                        {total >= 20 && <li className={perPage === 20 ? 'selected-item' : ''} onClick={() => { setPerPage(20); setCurrentPage(1); setShowingDropdownOpen(false); }}>20</li>}
                        {total >= 30 && <li className={perPage === 30 ? 'selected-item' : ''} onClick={() => { setPerPage(30); setCurrentPage(1); setShowingDropdownOpen(false); }}>30</li>}
                        {total >= 40 && <li className={perPage === 40 ? 'selected-item' : ''} onClick={() => { setPerPage(40); setCurrentPage(1); setShowingDropdownOpen(false); }}>40</li>}
                        {total >= 10 && <li className={total >= 10 && perPage === total ? 'selected-item' : ''} onClick={() => { setPerPage(total); setCurrentPage(1); setShowingDropdownOpen(false); }}>ALL</li>}
                        {/* Add more conditions as needed */}
                        {total < 10 ? (
                          <li className={total < 10 ? 'selected-item' : ''} onClick={() => { setPerPage(total); setCurrentPage(1); setShowingDropdownOpen(false); }}>{total}</li>
                        ) : null}
                      </ul>
                    </div>
                  )}
                </div>
                <label>of {total} Results</label>
              </div>
            </div>
          </div>

          <div className="time-table" style={{ opacity: hasDataLoaded && isFetchingTimeOff ? 0.6 : 1, transition: 'opacity 0.2s ease' }}>
            <table style={{ minWidth: "50rem", width: "100%", textAlign: "left" }} className={`${timeOffLoading || isFetchingTimeOff ? "loading-fade" : ""}`} >
              <thead>
                <tr>
                  {(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 7) && (
                    <th style={{ minWidth: "300px" }}>User Name</th>
                  )}
                  <th>Type</th>
                  <th>Issue Date</th>
                  <th>Total Days</th>
                  <th>Days Filed Before Leave</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Status</th>
                  {/* {(user?.userType === userTypeConsts.SUPER_ADMIN || user?.userType === userTypeConsts.ADMIN) && ( */}
                  <th>Review By{" "}</th>
                  {/* )} */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {shouldShowSkeleton ? (
                  <TimeOffTableSkeleton
                    rows={perPage}
                    showUserColumn={user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 7}
                  />
                ) : timeoffDataOptimized.length === 0 ? (
                  <tr>
                    <td colSpan={user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 7 ? 10 : 9}>
                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
                        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2" />
                          <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2" />
                          <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round" />
                          <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round" />
                        </svg>
                        <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No time off requests found</p>
                        <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Try adjusting your filters or create a new request.</p>
                      </div>
                    </td>
                  </tr>
                ) : (
                  <>
                    {timeoffDataOptimized?.map((row, index) => (
                      <tr key={row._id || index}>
                        {(user.userType !== 3 && user.userType !== 5 && user.userType !== 4 && user.userType !== 7) && (
                          <td>
                            {row.userDetails && (
                              <div className="time0ff-membername">
                                <span className="user-image-listingteam">
                                  <img
                                    src={
                                      row.userDetails.profile_image
                                        ? `/uploads/lowProfileImage/${row.userDetails.profile_image}`
                                        : "/uploads/lowProfileImage/user_default.png"
                                    }
                                    alt={row.userDetails.first_name}
                                    className="member-image"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/uploads/lowProfileImage/user_default.png";
                                    }}
                                  />
                                </span>
                                <TruncateUserName
                                  textContent={row.userDetails?.first_name ? (
                                    <>
                                      {row.userDetails.first_name}{' '}
                                      {row.userDetails.middle_name && row.userDetails.middle_name !== 'null' ? row.userDetails.middle_name + ' ' : ''}
                                      {row.userDetails.last_name || ''}
                                    </>
                                  ) : (
                                    <>
                                      {row.userDetails?.company_first_name
                                        ? `${row.userDetails.company_first_name} ${row.userDetails.company_last_name ? row.userDetails.company_last_name : ''}`.trim()
                                        : `${row.userDetails?.company_name || ''}(Company)`}
                                    </>
                                  )}
                                />
                              </div>
                            )}
                          </td>
                        )}
                        <td>{row.leaveDetails?.leave_type || "N/A"}</td>
                        <td>
                          {row.created_at ? (
                            moment.tz(moment(row.created_at).format("YYYY-MM-DD"), global.config.getTimeZone()).locale("en-gb").format("MMMM DD, YYYY")
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>
                          {calculateNumberOfDays(
                            row.start_date,
                            row.start_time,
                            row.end_date,
                            row.end_time
                          )}
                        </td>
                        <td> {row.created_at && row.start_date ? (
                          calculateDaysBetweenDates(row.created_at, row.start_date)
                        ) : (
                          "N/A"
                        )}</td>
                        <td>
                          {row.start_date ? (
                            <DateConverter date={row.start_date} />
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td>
                          {row.end_date ? (
                            <DateConverter date={row.end_date} />
                          ) : (
                            "N/A"
                          )}
                        </td>
                        <td style={{ paddingRight: '30px' }}>
                          <div className={row?.status?.toLowerCase()}>
                            {row.status}
                          </div>
                        </td>
                        <td>
                          {row.torVerifiedByDetails ? (
                            <div className="time0ff-membername">
                              <span className="user-image-listingteam">
                                {row.torVerifiedByDetails.profile_image !== null &&
                                  row.torVerifiedByDetails.profile_image !== "null" ? (
                                  <img
                                    src={`/uploads/lowProfileImage/${row.torVerifiedByDetails.profile_image}`}
                                    alt={row.torVerifiedByDetails.first_name}
                                    className="member-image"
                                    onError={(e) => {
                                      e.target.onerror = null;
                                      e.target.src =
                                        "/uploads/lowProfileImage/user_default.png";
                                    }}
                                  />
                                ) : (
                                  <img
                                    src={profile_image}
                                    alt={row.torVerifiedByDetails.first_name || row.torVerifiedByDetails.company_name}
                                    className="member-image"
                                  />
                                )}
                              </span>
                              <TruncateUserName
                                textContent={row.torVerifiedByDetails?.first_name ? (
                                  <>
                                    {row.torVerifiedByDetails.first_name}{' '}
                                    {row.torVerifiedByDetails.middle_name && row.torVerifiedByDetails.middle_name !== 'null' ? row.torVerifiedByDetails.middle_name + ' ' : ''}
                                    {row.torVerifiedByDetails.last_name || ''}
                                  </>
                                ) : (
                                  <>
                                    {row.torVerifiedByDetails?.company_first_name
                                      ? `${row.torVerifiedByDetails.company_first_name} ${row.torVerifiedByDetails.company_last_name ? row.torVerifiedByDetails.company_last_name : ''}`.trim()
                                      : `${row.torVerifiedByDetails?.company_name || ''}(Company)`}
                                  </>
                                )}
                              />
                            </div>
                          ) : (
                            <div>
                              Not Verified
                            </div>
                          )}
                        </td>
                        <td>
                          <Link
                            to={`/user/time-off/view/${row._id}`}
                            className="cta-link"
                          >
                            Details
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </>
                )}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          {!shouldShowSkeleton && timeoffDataOptimized && timeoffDataOptimized.length > 0 && (
            <ul className="pagination">
              {currentPage > 1 && (
                <li className="back">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Back
                  </button>
                </li>
              )}
              {getPaginationPages().map((pageNum, index) => {
                if (pageNum === 'ellipsis-start') {
                  // Calculate middle page between first and current visible range
                  const midPage = Math.floor((1 + currentPage) / 2);
                  return (
                    <li key={`ellipsis-start-${index}`} className="ellipsis">
                      <button
                        onClick={() => handlePageChange(midPage)}
                        title={`Go to page ${midPage}`}
                      >
                        ...
                      </button>
                    </li>
                  );
                } else if (pageNum === 'ellipsis-end') {
                  // Calculate middle page between current visible range and last
                  const midPage = Math.floor((currentPage + totalPages) / 2);
                  return (
                    <li key={`ellipsis-end-${index}`} className="ellipsis">
                      <button
                        onClick={() => handlePageChange(midPage)}
                        title={`Go to page ${midPage}`}
                      >
                        ...
                      </button>
                    </li>
                  );
                } else {
                  return (
                    <li key={pageNum} className={currentPage === pageNum ? "active" : ""}>
                      <button onClick={() => handlePageChange(pageNum)}>{pageNum}</button>
                    </li>
                  );
                }
              })}
              {currentPage < totalPages && (
                <li className="next">
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </li>
              )}
            </ul>
          )}
        </div>
        {/* new table */}
      </motion.div>
    </>
  );
};
export default TimeOffs;